export const EN = {
  AactivityOnboarding: {
    SUMMARY: {
      ACTIVITY_TEXT: 'Frequency of outings'
    }
  },
  CANCEL_SUBSCRIPTION: {
    FIRST_SCREEN_XSXTmention: '*For XS and XT trackers only'
  },
  HipayPayments: {
    CARDNUMBER: 'Card number',
    EXPIRYDATE: 'Expiry date',
    FULLNAME: 'Full name',
    GOCARDLESS_LINK: 'Pay by bank debit',
    YOURNAME: 'Your name'
  },
  Slider: {
    GPS_INTERVAL: 'GPS frequency',
    GPS_POSITION_REPORT_ENABLED: 'GPS position report enabled',
    TRACKER_INTERVAL_TEXT_WARNING: 'Disabling GPS position tracking will increase battery life, but the safety areas and history will no longer work.'
  },
  TypeSwitch: {
    ANIMAL_SUBTITLE: 'Choose the pet for which you bought this tracker:',
    CAT_TYPE: 'Cat tracker',
    DOG_TYPE: 'Dog tracker',
    FAMILY_SUBTITLE: 'Who did you buy this tracker for?',
    KID_TYPE: 'A child',
    SILVER_TYPE: 'A senior citizen',
    TITLE: 'Who is the tracker for?'
  },
  account: {
    LANGUAGE: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'A problem occurred',
        UPDATE_SUCCESS: 'Language updated'
      }
    },
    NAV: {
      LANGUAGE: 'Language',
      PASSWORD: 'Password',
      PAYMENTS: 'Payment and invoicing',
      USER_PREFERENCES: 'Preferences',
      USER_PROFILE: 'User profile'
    },
    PASSWORD: {
      HEADLINE: 'Password change',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'A problem occurred',
        UPDATE_ERROR_WRONG_PASSWORD: 'The old password you entered is incorrect',
        UPDATE_SUCCESS: 'Password changed'
      }
    },
    PAYMENTS: {
      HISTORY_HEADLINE: 'Payment history',
      MAIN_HEADLINE: 'Invoicing'
    },
    USER_PREFERENCES: {
      EMAIL_PREFERENCES_HEADLINE: 'Email preferences',
      EMAIL_PREFERENCES_USER_INFO: 'The preferences will be applied to the email address {{user_email}}',
      MAIN_HEADLINE: 'Preferences',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'A problem occurred while saving preferences',
        UPDATE_SUCCESS: 'Preferences updated successfully'
      },
      METRIC_PREFERENCES_DESCRIPTION: 'Choose the distance unit used for your tracker.',
      METRIC_PREFERENCES_HEADLINE: 'Metric system preference'
    },
    USER_PROFILE: {
      BASIC_INFO_HEADLINE: 'Basic information',
      BILLING_HEADLINE: 'Invoicing address',
      MAIN_HEADLINE: 'User profile',
      MARKETING_AGREEMENT_TEXT: 'I agree to receive special offers and promotions from Weenect\'s partners',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'A problem occurred',
        UPDATE_SUCCESS: 'Information updated'
      },
      METRIC_KM: 'Kilometers',
      METRIC_MILES: 'Miles',
      PREFERRED_METRIC: 'Measurements to use:'
    }
  },
  accounttab: {
    CANCEL_CTA: 'Cancel',
    ERROR_EMAIL_ALREADY_USED: 'This email address is already associated with an account',
    ERROR_FORMAT: 'Sorry, this format is not valid',
    ERROR_INVALID_CREDENTIALS: 'Invalid password.',
    ERROR_NETWORK: 'An unexpected error occurred. Please try again.',
    PASSWORD_CHANGE_SUBTITLE: 'Change password',
    PASSWORD_LENGTH_ERROR: 'The password must be at least 8 characters long',
    PASSWORD_LENGTH_HELPER: 'Minimum length: 8 characters',
    PASSWORD_NEW_LABEL: 'New password',
    PASSWORD_OLD_LABEL: 'Old password',
    PASSWORD_SECTION_TITLE: 'Password',
    PASSWORD_SECURITY_NOTE: 'For your security, changing your password will log you out of all devices. You will need to log in again with the new password.',
    PREF_DISPLAY_THEME_DARK: 'Dark',
    PREF_DISPLAY_THEME_DESCRIPTION: 'Choose the display theme for your Weenect space.',
    PREF_DISPLAY_THEME_LIGHT: 'Light',
    PREF_DISPLAY_THEME_SYSTEM: 'System',
    PREF_DISPLAY_THEME_TITLE: 'Theme',
    PREF_EMAILS_COMPANY_NEWS: 'Company news',
    PREF_EMAILS_DESCRIPTION: 'Choose the types of emails you want to receive. We will only send those matching your choices. Preferences will apply to the email address {{email}}',
    PREF_EMAILS_NEW_FEATURES: 'New features',
    PREF_EMAILS_OFFERS: 'Promotional offers',
    PREF_EMAILS_PARTNERS_CONSENT: 'I agree to receive offers and promotions from Weenect partners',
    PREF_EMAILS_SUBTITLE: 'Email preferences',
    PREF_EMAILS_SURVEYS_BETA: 'Surveys and beta tests',
    PREF_METRIC_DESCRIPTION: 'Choose the distance unit used for your tracker.',
    PREF_METRIC_KM: 'Kilometers',
    PREF_METRIC_MILES: 'Miles',
    PREF_METRIC_SUBTITLE: 'Measurement system preference',
    PREF_SECTION_TITLE: 'Preferences',
    PREF_TRACKING_CONSENT: 'I agree to email open tracking',
    PREF_TRACKING_DESCRIPTION: 'Open tracking helps us measure the effectiveness of our communications and adjust the frequency and content of our emails.',
    PREF_TRACKING_SUBTITLE: 'Email open tracking',
    PREF_WEENECT_ANGELS_DISTANCE_DESCRIPTION: 'Choose the distance around your tracker to display reported lost animals.',
    PREF_WEENECT_ANGELS_DISTANCE_VALUE: '{{km}} km',
    PREF_WEENECT_ANGELS_NOTIF_CONSENT: 'I agree to receive notifications for Weenect Angels',
    PREF_WEENECT_ANGELS_NOTIF_DESCRIPTION: 'Do you want to receive notifications related to this feature?',
    PREF_WEENECT_ANGELS_TITLE: 'Weenect Angels',
    PROFIL_ADDRESS_PLACEHOLDER: 'Address',
    PROFIL_BASIC_INFO_SUBTITLE: 'Basic information',
    PROFIL_BILLING_ADDRESS_SUBTITLE: 'Billing address',
    PROFIL_CITY_PLACEHOLDER: 'City',
    PROFIL_COUNTRY_PLACEHOLDER: 'Country',
    PROFIL_EMAIL_PLACEHOLDER: 'Email address',
    PROFIL_FIRSTNAME_PLACEHOLDER: 'First name',
    PROFIL_LASTNAME_PLACEHOLDER: 'Last name',
    PROFIL_PHONE_PLACEHOLDER: 'Phone number',
    PROFIL_POSTAL_CODE_PLACEHOLDER: 'Zip code',
    PROFIL_SECTION_TITLE: 'User profile',
    SAVE_CTA: 'Save'
  },
  activity: {
    AVERAGE_SPEED: 'Average speed',
    CONTROLS: {
      PAUSE_PLAYING_TITLE: 'Pause history playback',
      RESUME_PLAYING_TITLE: 'Restart history playback',
      START_PLAYING: 'Launch',
      START_PLAYING_TITLE: 'Start history playback',
      STOP_PLAYING: 'Stop',
      STOP_PLAYING_TITLE: 'Stop history playback',
      TOGGLE_HEATMAP: 'Heatmap',
      TOGGLE_HEATMAP_TITLE: 'Display the heatmap',
      TOGGLE_PATH: 'Plot of positions',
      TOGGLE_PATH_TITLE: 'Display position plot'
    },
    DETAIL_TITLE: 'Activity details',
    EMPTY_LIST: 'No alerts to display. Change the period selected or check that the tracker is turned on.',
    EVENTS: {
      ALERT: 'Lateral button activated',
      BATTERY: 'Low battery - {{battery}}% remaining',
      CALL_END: 'SOS call ended',
      CALL_REQ: 'SOS call requested',
      ENTERS_GEOFENCE: 'Geofence entry',
      EXIT_GEOFENCE: 'Geofence exit',
      FLASH_REQ: 'Flash requested',
      FREQ_CHANGE: 'Frequency modified',
      RING: 'Ringtone performed',
      RING_REQ: 'The ringtone has been requested',
      SOS: 'SOS alert',
      TRACKER_OFF: 'Tracker switched off',
      TRACKER_ON: 'Tracker switched on',
      VIBRATE: 'Vibration performed',
      VIBRATE_REQ: 'Vibrator selected'
    },
    FEEDBACKTEXT: {
      FIRST: '',
      SECOND: ''
    },
    HISTORY_TITLE: 'Notifications history',
    LAST_TIME_PERIOD: 'Show last',
    LOADING: 'Loading...',
    MAXIMUM_SPEED: 'Maximum speed',
    OBJECTIVE: {
      CONTENT: 'Set a daily intense activity goal.',
      DAILY_REACHED: '{{name}} has reached her daily goal!',
      HELPTEXT: 'Only intense activity is taken into account when measuring the daily goal. Like a run or a play session for example.',
      RECOMENDED_VALUE: 'Recommended goal: 1 hour',
      SUBTEXT: 'Our algorithm records every movement of your tracker and then classifies the results by intensity level. This way we can determine if it is an intense, moderate or low activity.',
      TITLE: 'Daily goal'
    },
    ONBOARDING: {
      FIRST_SUBTEXT: 'This tool helps you keep track of your furball\'s daily activity.',
      SECOND_SUBTEXT: 'How long did he sleep? How many steps did he take today?',
      START: 'Start!',
      THIRD_SUBTEXT: 'You\'ll even be able to set a goal based on your pet\'s breed, so that your pet gets the daily activity it needs.',
      TITLE: 'Welcome to the Weenect activity-tracking !'
    },
    PROGRESSBAR: {
      TITLE: 'Daily goal'
    },
    REPARTION: {
      DAY: 'Today.',
      MONTH: 'over the last 30 days',
      WEEK: 'over the last 7 days'
    },
    SELECT_DAY: 'Choose a day to display',
    SELECT_TIME: 'Use slider to select the time interval to display',
    SUMMARY: {
      ACTIVITY: 'Intense',
      AWAKENING: 'Moderate',
      DATEINTERVAL: '',
      DAY_INDEX: 'd',
      DISTRIBUTIONTEXT: 'Detailed report',
      HOUR_INDEX: 'h',
      LASTWEEK: '',
      MENU_TITLE: 'Activity report',
      MIN_INDEX: 'min',
      MODIFY_PERIOD: 'Change the period',
      PREVIOUS_DAY: '',
      PREVIOUS_MONTH: '',
      PREVIOUS_WEEK: '',
      REGISTERED_ACTIVITY: 'steps',
      REPORT: 'View report ',
      REST: 'Low',
      SUBTEXT: '{{time}} of intense activity left before reaching {{name}}\'s goal.',
      TEXT_OBJECTIVE_COMPLETED: '{{name}} has reached her daily goal!',
      TEXT_OBJECTIVE_COMPLETED_TREAT: 'Congratulations, {{name}} has achieved her goal! Maybe that deserves a treat?',
      TEXT_OBJECTIVE_NONE: '{{name}} has no data for this period',
      TEXT_OBJECTIVE_NONE_VERIFY_TRACKER: '{{name}} hasn\'t recorded any movements yet. Check that your tracker is switched on and the battery is charged!',
      TITTLE: '{{name}} progress',
      TODAY: 'Today,',
      TOTAL: 'Total',
      YESTERDAY: 'Yesterday'
    },
    TIME_ELAPSED: 'Period',
    TOTAL_DISTANCE: 'Total distance'
  },
  activityGeneral: {
    BEHAVIOR: 'Activity',
    STANDARD_MORPHOLOGY: 'Morphology ',
    STERILIZED: 'Sterilized'
  },
  activityOnboarding: {
    COMMON: {
      STEP: 'Step',
      TRACKER_PROFIL: 'Tracker profile'
    },
    MONTH: {
      APRIL: 'April',
      AUGUST: 'August',
      DECEMBER: 'December',
      FEBRUARY: 'February',
      JANUARY: 'January',
      JULY: 'July',
      JUNE: 'June',
      MARCH: 'March',
      MAY: 'May',
      NOVEMBER: 'November',
      OCTOBER: 'October',
      SEPTEMBER: 'September'
    },
    PET_ACTIVITY: {
      FIRST_BUTTON: 'Sedentary',
      FIRST_BUTTON_CAT: 'Exceptionally (holidays, unforeseen events...)',
      FIRST_BUTTON_DOG: 'For its business only',
      FOURTH_BUTTON: 'Hyperactive (2 to 3 walks per day)',
      FOURTH_BUTTON_CAT: 'Regularly, day and night',
      FOURTH_BUTTON_DOG: 'Two or three walks per day',
      SECOND_BUTTON: 'Average (2 to 3 walks per week)',
      SECOND_BUTTON_CAT: 'From time to time, on request',
      SECOND_BUTTON_DOG: 'Two or three walks per week',
      SELECT_ACTIVITY: 'How often does it go out?',
      THIRD_BUTTON: 'Energetic (one walk per day)',
      THIRD_BUTTON_CAT: 'Regularly, during the day\n',
      THIRD_BUTTON_DOG: 'One walk per day',
      TITLE: 'How active is it?'
    },
    PET_AGE: {
      FIRST_COMMON_TEXT: 'year(s) and ',
      SECOND_COMMON_TEXT: 'month(s)',
      TITLE: 'What is its date of birth?'
    },
    PET_GENDER: {
      FEMALE: 'A female',
      FIRST_TITLE: 'What is the gender of your pet?',
      MALE: 'A male',
      SECOND_TITLE: 'Is your pet sterilized?'
    },
    PET_HEALTH: {
      LAST_VACINATION: 'What about the last vaccination?',
      LAST_VET_VISIT: 'When was the last time your pet went to the vet?',
      TITLE: 'Health point'
    },
    PET_IDENTIFICATION: {
      CHIP: 'Chip',
      NONE: 'My pet does not have any form of identification',
      SELECT_IDENTIFICATION: 'What is its identification?',
      TATTOO: 'Tattoo'
    },
    PET_INFO: {
      GET_STARTED: 'Let\'s get started!',
      NEED_TO_KNOW: 'We need to get to know  {{name}} .',
      PETS_DETAILS: 'Please enter your pet\'s details.',
      PETS_GENDER: {
        MIXED_BREED: 'It is a crossbred'
      },
      PET_GENDER_COMMON: 'To begin with, your pet is: ',
      SECOND_PETS_DETAILS: 'Enter your pet\'s details'
    },
    PET_MORPH: {
      AVERAGE: 'Average',
      COMMON_TEXT: 'Around',
      FIRST_TITLE: 'What is its body type?',
      HELP_TEXT: 'How to define the morphology of my animal?\n',
      LEAN: 'Lean',
      OBESE: 'Obese',
      OVERWEIGHT: 'Overweight',
      SECOND_TITLE: 'What does it weigh?',
      WEIGH_TEXT: 'How much does your pet weigh?'
    },
    PET_NAME: {
      COMMON_TEXT: 'Let\'s get to know your furball! You can change this information in the settings.',
      PLACEHOLDER: 'Your pet\'s name',
      TITLE: 'What is your pet called?'
    },
    PET_RACE: {
      COMMON_TEXT: 'I don\'t know its breed',
      PLACEHOLDER: 'What is your dog\'s breed?',
      SELECT_BREED: 'Select its breed',
      TITLE: 'What is your pet\'s breed ?'
    },
    PET_TYPE: {
      CAT: 'A cat',
      DOG: 'A dog'
    },
    SUMMARY: {
      BIRTH_DATE: 'Date of birth',
      BREED: 'Breed',
      CONDITION: 'Condition',
      DAILY_EXERCISE: 'Daily exercise',
      DELETE: 'Reset profile.',
      HEALTH: 'Health',
      IDENTIFICATION: 'Identification',
      MODAL: {
        NO: 'No, cancel',
        SUBTEXT: 'You will then have to start the process all over again.',
        TITLE: 'Are you sure you want to reset your pet\'s information?',
        YES: 'Yes i\'m sure'
      },
      MORPHOLOGY: 'Build/body type',
      NAME: 'Name',
      RECAPTEXT: 'Here is the information about your companion.',
      SEX: 'Sex',
      SPECIES: 'Species',
      SUBMIT: 'Confirm profile',
      UNSPECIFIED: 'unspecified',
      VALIDATION: 'Profile verification',
      VALIDATION_TEXT: 'Please confirm your details before continuing. ',
      WEIGHT: 'Weight'
    }
  },
  activityTracking: {
    ACTIVITY: 'of activity',
    ACTIVITY_DISTRIBUTION: {
      DATA_COMPARATOR: {
        ACTIVITY_INTENSE: 'Intense activity',
        ACTIVITY_INTENSE_LEGEND: 'of intense activity {{day}}',
        ACTIVITY_INTENSE_LEGEND1_DAY: 'intense activity yesterday',
        ACTIVITY_INTENSE_LEGEND1_MONTH: 'intense activity this month',
        ACTIVITY_INTENSE_LEGEND1_WEEK: 'intense activity this week.',
        ACTIVITY_INTENSE_LEGEND2_DAY: 'intense activity the day before yesterday',
        ACTIVITY_INTENSE_LEGEND2_MONTH: 'intense activity last month',
        ACTIVITY_INTENSE_LEGEND2_WEEK: 'intense activity last week.',
        ACTIVITY_LOW_LEGEND1_DAY: 'low activity yesterday',
        ACTIVITY_LOW_LEGEND1_MONTH: 'low activity this month',
        ACTIVITY_LOW_LEGEND1_WEEK: 'low activity this week.',
        ACTIVITY_LOW_LEGEND2_DAY: 'low activity the day before yesterday',
        ACTIVITY_LOW_LEGEND2_MONTH: 'low activity last month',
        ACTIVITY_LOW_LEGEND2_WEEK: 'low activity last week.',
        ACTIVITY_MODERATE: 'Moderate activity',
        ACTIVITY_MODERATE_LEGEND: 'of moderate activity {{day}}',
        ACTIVITY_MODERATE_LEGEND1_DAY: 'moderate activity yesterday',
        ACTIVITY_MODERATE_LEGEND1_MONTH: 'moderate activity this month',
        ACTIVITY_MODERATE_LEGEND1_WEEK: 'moderate activity this week.',
        ACTIVITY_MODERATE_LEGEND2_DAY: 'moderate activity the day before yesterday',
        ACTIVITY_MODERATE_LEGEND2_MONTH: 'moderate activity last month',
        ACTIVITY_MODERATE_LEGEND2_WEEK: 'moderate activity last week.',
        ACTIVITY_WEAK: 'Low activity',
        ACTIVITY_WEAK_LEGEND: 'of low activity {{day}}',
        TEXT: '{{petName}} had {{comparator}} {{activity}} activity span yesterday than {{day}}.'
      }
    },
    ACTIVITY_REPORT: {
      DATA_COMPARATOR: {
        LEGEND: {
          KM_MONTHLY: 'kilometers daily on average this month',
          KM_WEEKLY: 'kilometers daily on average this week',
          KM_YESTERDAY: 'kilometers covered yesterday',
          STEP_MONTHLY: 'daily steps on average this month',
          STEP_WEEKLY: 'daily steps on average this week',
          STEP_YESTERDAY: 'steps taken yesterday'
        },
        LEGEND1: {
          STEP_DAY: 'steps taken yesterday.',
          STEP_MONTH: 'average daily steps this week',
          STEP_WEEK: 'steps taken yesterday'
        },
        LEGEND2: {
          STEP_DAY: 'steps taken the day before yesterday',
          STEP_MONTH: 'average daily steps this month.',
          STEP_WEEK: 'average daily steps over the previous 7 days'
        },
        TEXT_INF: 'lower than',
        TEXT_KM_DAILY: 'Yesterday\'s distance covered by {{petName}} was {{comparator}} the day before yesterday.',
        TEXT_KM_MONTHLY: 'This week\'s average distance covered by {{petName}} is {{comparator}} this month\'s average.',
        TEXT_KM_WEEKLY: 'Yesterday\'s distance covered by {{petName}} is {{comparator}} their weekly average.',
        TEXT_SIM: 'similar to',
        TEXT_STEP_DAILY: '{{petName}}\'s steps taken yesterday were {{comparator}} the day before yesterday.',
        TEXT_STEP_MONTHLY: '{{petName}}\'s average steps taken this week were {{comparator}} this month\'s current average.',
        TEXT_STEP_WEEKLY: 'The steps taken yesterday were {{comparator}} {{petName}}\'s weekly average.',
        TEXT_SUP: 'higher than',
        TITLE_KM_TRAVELED: 'Kilometers covered',
        TITLE_STEP: 'Steps taken'
      },
      KM_TRAVELED: '{{step}} kilometers covered'
    },
    AIMED_GOAL: {
      ALERT: 'We recommend a daily goal of at least 3 hours to keep your pet healthy.',
      TITLE: 'Set a daily activity goal.'
    },
    DAILY_CHART: '{{petName}}\'s Activity',
    DAILY_GOAL: {
      NOT_RECOMMENDED: 'Not recommended goal',
      RECOMMENDED: 'Recommended goal',
      SECOND_TITLE: 'Daily goal',
      TITLE: 'Daily goal'
    },
    DAILY_STEP: 'Daily steps',
    DAYS: 'Day',
    EQUAL: 'the same',
    ERROR_PAGE: {
      BUTTON_TEXT: 'Close page',
      TEXT: 'We\'re unable to load the page right now. Please try again later.',
      TITLE: 'Oops, we\'ve encountered a problem...'
    },
    HEADER: {
      ACTIVITY_DISTRIBUTION: {
        TITLE: 'Activity Breakdown'
      },
      ACTIVITY_REPORT: {
        TITLE: 'Activity Reports'
      },
      GOAL: {
        TITLE: 'Daily goal'
      }
    },
    HOME: {
      ACTIVITY_DISTRIBUTION: {
        INTENSE: 'Intense',
        MODERATE: 'Moderate',
        WEAK: 'Low'
      },
      ALERT: 'A few learning days are needed to ensure reliable data. During this period, the algorithm gathers and analyzes your data to understand your pet\'s activity patterns and habits. Over time, the results will become more accurate and tailored to their profile.',
      FIRST_SECTION: {
        TITLE: 'Daily goal'
      },
      INSURANCE: {
        BUTTON: 'Discover Weenect Insurance',
        TEXT: 'A vet visit is a must. Trust Weenect for a refund of your consultation.'
      },
      MODIFY: 'Modify',
      PROFILE: {
        SUBTITLE: 'Monitor their daily activity to keep them in shape.'
      },
      SECOND_SECTION: {
        SUBTITLE: 'For the current day.',
        TITLE: 'Distribution'
      },
      SEE_MORE: 'See more',
      THIRD_SECTION: {
        TITLE: 'Highlights'
      }
    },
    HOUR: '{{count}} h',
    HOURS: 'Hours',
    INTERVAL: {
      TEXT: 'Move the edges of the graph to change the period displayed.',
      TITLE: 'Period selection'
    },
    KEY_POINTS: 'Highlights',
    KILOMETERS: 'Kilometers',
    LESS: 'a shorter',
    MIN: 'Minutes',
    MINUTE_ACTIVITY_one: '{{count}} minute of activity',
    MINUTE_ACTIVITY_other: '{{count}} minutes of activity',
    MINUTE_one: '{{count}} minute',
    MINUTE_other: '{{count}} minutes',
    MIN_one: '{{count}} min',
    MIN_other: '{{count}} min',
    MONTHLY_STEP: 'Monthly steps',
    ONBOARDING: {
      FIRST_STEP: {
        ALERT: 'In airplane mode, the activity continues to be tracked. It will appear in the dashboard as soon as you leave the wifi area.',
        BUTTON: 'Start',
        MESSAGE: 'This tool helps you keep track of your furball\'s daily activity.  How long did your pet sleep? How many steps did they take today? You\'ll soon know it all!',
        TITLE: 'Welcome to your pet\'s activity tracking!'
      },
      SECONDE_STEP: {
        BUTTON: 'Save',
        PROFILE: {
          SUBTITLE: 'Monitor their daily activity to keep them in shape.',
          TITLE: '{{petName}}\'s Activity'
        },
        TITLE: 'Set a daily activity goal.'
      }
    },
    PERIOD: {
      DAY: 'Day',
      MONTH: 'Month',
      TITLE: 'Period selection',
      WEEK: 'Week',
      YEAR: 'Year'
    },
    PLUS: 'a longer',
    RETURN_HOME: 'Return to home page',
    STEP: 'Steps',
    STEP_SAVED: '{{step}} steps',
    TEXT: 'This graph shows you the activity of your pet. The measurement of this activity is done at an interval of between 0 and infinity. Each activity point represents a change, i.e. that your pet is on the move.',
    TITLE_DAY: 'Today, {{DATE}}',
    TITLE_MONTH: 'Month from {{DAY1}} to {{DAY2}}',
    TITLE_WEEK: 'Week from {{DAY1}} to {{DAY2}}',
    TOTAL: 'Total',
    WEEKDAYS: {
      FRIDAY: 'Friday',
      FRIDAY_COMPARATIVE: 'on Friday',
      MONDAY: 'Monday',
      MONDAY_COMPARATIVE: 'on Monday',
      SATURDAY: 'Saturday',
      SATURDAY_COMPARATIVE: 'on Saturday',
      SUNDAY: 'Sunday',
      SUNDAY_COMPARATIVE: 'on Sunday',
      THURSDAY: 'Thursday',
      THURSDAY_COMPARATIVE: 'on Thursday',
      TUESDAY: 'Tuesday',
      TUESDAY_COMPARATIVE: 'on Tuesday',
      WEDNESDAY: 'Wednesday',
      WEDNESDAY_COMPARATIVE: 'on Wednesday'
    },
    WEEKLY_STEP: 'Weekly steps',
    YESTERDAY: 'yesterday'
  },
  address: {
    CITY_PLACEHOLDER: 'City',
    COUNTRY_PLACEHOLDER: 'Country',
    LANGUAGE_PLACEHOLDER: 'Language',
    POSTAL_CODE_PLACEHOLDER: 'Zip code',
    STREET_PLACEHOLDER: 'Number and street',
    SUBMIT_CTA: 'Continue',
    TITLE: 'What is your address?'
  },
  alertCustomer: {
    BODY0: 'Our SIM card provider is currently undergoing maintenance.',
    BODY1: 'During this period of maintenance <1>the delay for a SIM activation has been extended to 24h</1>.',
    BODY2: 'We are well aware of the inconvenience this poses. We apologise for this situation beyond our control.\n\nFor more information, you can contact our team at <1>family@weenect.com</1> or by phone at +442070391906.',
    FOOTER: 'Weenect Team'
  },
  animalInfo: {
    ERROR: 'Error',
    LANDING_PAGE: {
      BUTTON: 'Start',
      TEXT: 'Let\'s get to know your furball. You can change this information in the settings. ',
      TITLE: 'Enter your pet\'s information!',
      WARNING: 'This information is necessary for the most accurate activity tracking and to personalize your Weenect experience.'
    },
    NEXT_BUTTON: 'Next',
    PROFIL_VALIDATION: {
      ACTIVITY: 'Activity and behavior',
      BUTTON: 'Validate the profile',
      ERROR: 'Error',
      INDENTIFICATION_INFOS: 'Identification info',
      MEDICAL_HISTORY: 'Medical history',
      PERSONAL_INFOS: 'Personal info',
      PHYSICAL: 'Physical characteristics',
      SEX: 'Sex',
      SPECIES: 'Species',
      TITLE: 'Profile validation',
      UNIQUE_IDENTIFICATION: 'Unique identification'
    },
    QUESTION: 'Question',
    QUESTION_EIGHT: {
      NO: 'No',
      NOT_STERILIZED: 'Not neutered',
      QUESTION: 'Is your pet sterilized?',
      STERILIZATION_STATUS: 'Neutering status',
      STERILIZED: 'Neutered',
      YES: 'Yes'
    },
    QUESTION_ELEVEN: {
      EVERYTIME: 'Often',
      EXIT_FREQUENCY: 'Frequency of outings',
      MOSTLY: 'From time to time',
      OFTEN: 'Regularly',
      QUESTION: 'How often does it go out?',
      RARELY: 'Rarely'
    },
    QUESTION_FIVE: {
      QUESTION: 'How much does your pet weigh?',
      WEIGHT: 'Weight'
    },
    QUESTION_FOUR: {
      FEMALE: 'Female',
      MALE: 'Male',
      QUESTION: 'What is your pet\'s sex?'
    },
    QUESTION_NINE: {
      LAST_VISIT: 'Last vet visit',
      QUESTION: 'When was the last time your pet went to the vet?'
    },
    QUESTION_ONE: {
      CAT: 'A cat',
      DOG: 'A dog',
      QUESTION: 'What is your pet\'s profile?'
    },
    QUESTION_SEVEN: {
      CHIPED: 'Chip',
      IDENTIFICATION: 'Identification',
      NOT_IDENTIFIED: 'My pet is not identified',
      QUESTION: 'What is its identification?',
      TATTOED: 'Tattoo'
    },
    QUESTION_SIX: {
      QUESTION: 'What is your pet\'s breed?',
      RACE: 'Breed'
    },
    QUESTION_TEN: {
      LAST_VACCIN: 'Last vaccination',
      QUESTION: 'What about the last vaccination?'
    },
    QUESTION_THREE: {
      BIRTHDATE: 'Date of birth',
      QUESTION: 'What is its date of birth?'
    },
    QUESTION_TWO: {
      NAME: 'Name',
      QUESTION: 'What is its name?'
    },
    santevet: {
      description: 'Protect {{animal_name}} with the number one Health Insurance for dogs and cats.',
      optin: 'I agree to be contacted by Santévet to enjoy my first 3 months free.',
      title: '3 months free !'
    }
  },
  animalinfo: {
    AUTO_ADVANCE_HINT: 'Click on an answer: you will go directly to the next question.',
    BACK: 'Back',
    BIRTH_AGE_MONTHS: 'which is {{count}} months',
    BIRTH_AGE_YEAR: 'which is {{count}} year',
    BIRTH_AGE_YEARS: 'which is {{count}} years',
    BIRTH_APPROX_1_3: '1 to 3 years',
    BIRTH_APPROX_4_7: '4 to 7 years',
    BIRTH_APPROX_8_PLUS: '8 years and older',
    BIRTH_APPROX_LESS_1: 'Less than 1 year',
    BIRTH_APPROX_SUBTITLE: 'Enter their approximate age:',
    BIRTH_APPROX_TITLE: 'Don\'t know the exact date?',
    BIRTH_DAY: 'Day',
    BIRTH_DAY_PLACEHOLDER: 'DD',
    BIRTH_ERROR_FUTURE: 'The date of birth cannot be in the future.',
    BIRTH_ERROR_INVALID: 'This date does not exist.',
    BIRTH_MONTH: 'Month',
    BIRTH_MONTH_PLACEHOLDER: 'MM',
    BIRTH_TITLE_FEMALE: 'When was {{name}} born?',
    BIRTH_TITLE_MALE: 'When was {{name}} born?',
    BIRTH_YEAR: 'Year',
    BIRTH_YEAR_PLACEHOLDER: 'YYYY',
    BREED_MIXED: 'Mixed',
    BREED_NO_PRECISE: 'No specific breed?',
    BREED_NO_RESULT: 'No breed found. Try another name or choose "Mixed".',
    BREED_SEARCH_PLACEHOLDER: 'Search for a breed',
    BREED_TITLE: 'What is their breed?',
    BREED_UNKNOWN: 'I don\'t know',
    CLOSE: 'Close',
    CONTINUE: 'Continue',
    ERROR_GENERIC: 'An error occurred. Please try again.',
    GENDER_FEMALE: 'A female',
    GENDER_MALE: 'A male',
    GENDER_TITLE: '{{name}} is...',
    HEADER_TITLE: '{{name}}\'s Profile',
    IDENTIFICATION_CHIP_DESC: 'Microchip under the skin',
    IDENTIFICATION_CHIP_FEMALE: 'Chipped',
    IDENTIFICATION_CHIP_MALE: 'Chipped',
    IDENTIFICATION_CHIP_NUMBER_HELP_FEMALE: 'Helps identify them faster if lost. 15 digits, on their health record or ID card.',
    IDENTIFICATION_CHIP_NUMBER_HELP_MALE: 'Helps identify them faster if lost. 15 digits, on their health record or ID card.',
    IDENTIFICATION_CHIP_NUMBER_LABEL: 'Chip number (optional)',
    IDENTIFICATION_NONE: 'Neither',
    IDENTIFICATION_NONE_DESC: 'Or I don\'t know',
    IDENTIFICATION_TATTOO_DESC: 'Tattoo on ear or thigh',
    IDENTIFICATION_TATTOO_FEMALE: 'Tattooed',
    IDENTIFICATION_TATTOO_MALE: 'Tattooed',
    IDENTIFICATION_TATTOO_NUMBER_HELP_FEMALE: 'Helps identify them faster if lost. As shown on their ID card.',
    IDENTIFICATION_TATTOO_NUMBER_HELP_MALE: 'Helps identify them faster if lost. As shown on their ID card.',
    IDENTIFICATION_TATTOO_NUMBER_LABEL: 'Tattoo number (optional)',
    IDENTIFICATION_TATTOO_NUMBER_PLACEHOLDER: 'Letters and numbers',
    IDENTIFICATION_TITLE_FEMALE: 'Is {{name}} identified?',
    IDENTIFICATION_TITLE_MALE: 'Is {{name}} identified?',
    INTRO_CTA: 'Let\'s go',
    INTRO_INFO: 'This information makes {{name}}\'s activity tracking more accurate and personalizes your Weenect experience.',
    INTRO_SUBTITLE: '6 quick questions. Everything can be changed later in their profile.',
    INTRO_TITLE: 'Let\'s get to know {{name}}',
    NEUTERING_TITLE_FEMALE: 'Is {{name}} sterilized?',
    NEUTERING_TITLE_MALE: 'Is {{name}} sterilized?',
    NO: 'No',
    PROGRESS: 'Question {{current}} of {{total}}',
    RECAP_BIRTH_APPROX: 'Approximate age: {{range}}',
    RECAP_BREED_UNKNOWN: 'Unknown',
    RECAP_CTA: 'Confirm profile',
    RECAP_EDIT: 'Edit',
    RECAP_FEMALE: 'Female',
    RECAP_HEADER: 'Verification',
    RECAP_IDENTIFICATION_NONE: 'None',
    RECAP_LABEL_BIRTH: 'Date of birth',
    RECAP_LABEL_BREED: 'Breed',
    RECAP_LABEL_GENDER: 'Sex',
    RECAP_LABEL_IDENTIFICATION: 'Identification',
    RECAP_LABEL_NEUTERING_FEMALE: 'Sterilized',
    RECAP_LABEL_NEUTERING_MALE: 'Sterilized',
    RECAP_LABEL_VET: 'Last vet visit',
    RECAP_MALE: 'Male',
    RECAP_SUBTITLE: 'Check their information before confirming.',
    RECAP_TITLE: 'Is everything correct for {{name}}?',
    RECAP_VET_UNKNOWN: 'Not provided',
    VET_ERROR_BEFORE_BIRTH: 'This date is before their birth.',
    VET_ERROR_FUTURE: 'This date cannot be in the future.',
    VET_MONTH: 'Month',
    VET_TITLE_FEMALE: 'When did they last see the vet?',
    VET_TITLE_MALE: 'When did they last see the vet?',
    VET_UNKNOWN: 'I don\'t remember',
    VET_YEAR: 'Year',
    YES: 'Yes'
  },
  breed: {
    CAT: {
      ABYSSINIAN: 'Abyssinian',
      AMERICAN_BOBTAIL: 'American Bobtail',
      AMERICAN_CURL: 'American Curl',
      AMERICAN_SHORTHAIR: 'American Shorthair',
      AMERICAN_WIREHAIR: 'American Wirehair',
      BALINESE: 'Balinese',
      BENGAL: 'Bengal',
      BIRMAN: 'Birman',
      BOMBAY: 'Bombay',
      BURMESE: 'Burmese',
      BURMILLA: 'Burmilla',
      CALIFORNIA_SPANGLED_CAT: 'California Spangled Cat',
      CHANTILLYTIFFANY: 'Chantilly-Tiffany',
      CHARTREUX: 'Chartreux',
      CORNISH_REX: 'Cornish Rex',
      CYMRIC: 'Cymric',
      DEVON_REX: 'Devon Rex',
      EGYPTIAN_MAU: 'Egyptian Mau',
      EUROPEAN: 'European',
      EXOTIC_SHORTHAIR: 'Exotic Shorthair',
      HAVANA: 'Havana',
      JAPANESE_BOBTAIL: 'Japanese Bobtail',
      JAVANESE: 'Javanese',
      KORAT: 'Korat',
      MAINE_COON: 'Maine Coon',
      MALAYAN: 'Malayan',
      MANX: 'Manx',
      MUNCHKIN: 'Munchkin',
      NEBELUNG: 'Nebelung',
      NORWEGIAN: 'Norwegian',
      NORWEGIAN_FOREST_CAT: 'Norwegian Forest Cat',
      OCICAT: 'Ocicat',
      ORIENTAL_LONGHAIR: 'Oriental Longhair',
      ORIENTAL_SHORTHAIR: 'Oriental Shorthair',
      PERSIAN: 'Persian',
      RAGDOLL: 'Ragdoll',
      RUSSIAN_BLUE: 'Russian Blue',
      SAFARI_CAT: 'Safari Cat',
      SCOTTISH_FOLD: 'Scottish Fold',
      SELKIRK: 'Selkirk',
      SIAMESE: 'Siamese',
      SIBERIAN: 'Siberian',
      SINGAPURA: 'Singapura',
      SNOWSHOE: 'Snowshoe',
      SOMALI: 'Somali',
      SPHYNX: 'Sphynx',
      THAI: 'Thai',
      TONKINESE: 'Tonkinese',
      TURKISH_ANGORA: 'Turkish Angora',
      TURKISH_VAN: 'Turkish Van'
    },
    DOG: {
      AFFENPINSCHER: 'Affenpinscher',
      AFGHAN_HOUND: 'Afghan Hound',
      AIREDALE_TERRIER: 'Airedale Terrier',
      AKITA: 'Akita',
      AKITA_INU_GREAT_JAPANESE_DOG: 'Akita Inu (Great Japanese Dog)',
      ALASKAN_MALAMUTE: 'Alaskan Malamute',
      ALPINE_DACHSBRACKE: 'Alpine Dachsbracke',
      AMERICAN_BULLDOG: 'American Bulldog',
      AMERICAN_COCKER_SPANIEL: 'American Cocker Spaniel',
      AMERICAN_FOXHOUND: 'American Foxhound',
      AMERICAN_STAFFORDSHIRE_TERRIER: 'American Staffordshire Terrier',
      AMERICAN_WATER_SPANIEL: 'American Water Spaniel',
      ANATOLIAN_SHEPHERD_DOG: 'Anatolian Shepherd Dog',
      APPENZELLER_SENNENHUND: 'Appenzeller Sennenhund',
      ARDENNES_CATTLE_DOG: 'Ardennes Cattle Dog',
      ARGENTINE_DOGO: 'Argentine Dogo',
      ARIEGEOIS: 'Ariégeois',
      ARIEGE_POINTER: 'Ariege Pointer',
      ARTOIS_HOUND: 'Artois Hound',
      ATLAS_SHEPHERD_DOG_AIDI: 'Atlas Shepherd Dog (Aidi)',
      AUSTRALIAN_CATTLE_DOG: 'Australian Cattle Dog',
      AUSTRALIAN_KELPIE: 'Australian Kelpie',
      AUSTRALIAN_SHEPHERD: 'Australian Shepherd',
      AUSTRALIAN_TERRIER: 'Australian Terrier',
      AUSTRIAN_BLACK_AND_TAN_HOUND: 'Austrian Black and Tan Hound',
      AUSTRIAN_SHORTHAIRED_PINSCHER: 'Austrian Shorthaired Pinscher',
      AZAWAKH: 'Azawakh',
      BALKAN_HOUND: 'Balkan Hound',
      BARBET: 'Barbet',
      BASENJI: 'Basenji',
      BASSET_ARTESIEN_NORMAND: 'Basset Artésien Normand',
      BASSET_BLEU_DE_GASCOGNE: 'Basset Bleu de Gascogne',
      BASSET_FAUVE_DE_BRETAGNE: 'Basset Fauve de Bretagne',
      BASSET_HOUND: 'Basset Hound',
      BAVARIAN_MOUNTAIN_SCENTHOUND: 'Bavarian Mountain Scenthound',
      BEAGLE: 'Beagle',
      BEARDED_COLLIE: 'Bearded Collie',
      BEAUCERON: 'Beauceron',
      BEDLINGTON_TERRIER: 'Bedlington Terrier',
      BELGIAN_GRIFFON: 'Belgian Griffon',
      BELGIAN_SHEPHERD_DOG_GROENENDAEL: 'Belgian Shepherd Dog (Groenendael)',
      BELGIAN_SHEPHERD_DOG_LAEKENOIS: 'Belgian Shepherd Dog (Laekenois)',
      BELGIAN_SHEPHERD_DOG_MALINOIS: 'Belgian Shepherd Dog (Malinois)',
      BELGIAN_SHEPHERD_DOG_TERVUREN: 'Belgian Shepherd Dog (Tervuren)',
      BERGAMASCO_SHEPHERD: 'Bergamasco Shepherd',
      BERNER_NIEDERLAUFHUND: 'Berner Niederlaufhund',
      BERNESE_HOUND: 'Bernese Hound',
      BERNESE_MOUNTAIN_DOG: 'Bernese Mountain Dog',
      BICHON_FRISE: 'Bichon Frise',
      BILLY_DOG: 'Billy (dog)',
      BLACK_AND_TAN_COONHOUND: 'Black and Tan Coonhound',
      BLOODHOUND_SAINTHUBERT_DOG: 'Bloodhound (Saint-Hubert Dog)',
      BLUE_PICARDY_SPANIEL: 'Blue Picardy Spaniel',
      BOHEMIAN_WIREHAIRED_POINTING_GRIFFON: 'Bohemian Wire-haired Pointing Griffon',
      BOLOGNESE_DOG: 'Bolognese (dog)',
      BORDEAUX_MASTIFF_FRENCH_MASTIFF: 'Bordeaux Mastiff (French Mastiff)',
      BORDER_COLLIE: 'Border Collie',
      BORDER_TERRIER: 'Border Terrier',
      BORZOI: 'Borzoi',
      BOSNIAN_COARSEHAIRED_HOUND: 'Bosnian Coarse-haired Hound',
      BOSTON_TERRIER: 'Boston Terrier',
      BOURBONNAIS_POINTER: 'Bourbonnais Pointer',
      BOUVIER_DES_FLANDRES: 'Bouvier des Flandres',
      BOXER_DOG: 'Boxer (dog)',
      BRAQUE_D_AUVERGNE: 'Braque d\'Auvergne',
      BRAZILIAN_TERRIER: 'Brazilian Terrier',
      BRIARD: 'Briard',
      BRIQUET_GRIFFON_VENDEEN: 'Briquet Griffon Vendéen',
      BRITTANY_SPANIEL: 'Brittany Spaniel',
      BROHOLMER: 'Broholmer',
      BRUNO_JURA_HOUND: 'Bruno Jura Hound',
      BRUNO_JURA_HOUND_BRUNO_TYPE: 'Bruno Jura Hound (Bruno type)',
      BRUNO_JURA_HOUND_ST_HUBERT_TYPE: 'Bruno Jura Hound (St. Hubert type)',
      BRUSSELS_GRIFFON: 'Brussels Griffon',
      BULLMASTIFF: 'Bullmastiff',
      BULL_TERRIER_ENGLISH_BULL_TERRIER: 'Bull Terrier (English Bull Terrier)',
      BURGOS_POINTER: 'Burgos Pointer',
      CAIRN_TERRIER: 'Cairn Terrier',
      CANAAN_DOG: 'Canaan Dog',
      CANARY_ISLAND_PODENCO: 'Canary Island Podenco',
      CANE_CORSO: 'Cane Corso',
      CAO_DE_CASTRO_LABOREIRO: 'Cão de Castro Laboreiro',
      CAO_FILA_DE_SAO_MIGUEL: 'Cão Fila de São Miguel',
      CATAHOULA_LEOPARD_DOG: 'Catahoula Leopard Dog',
      CATALAN_SHEEPDOG: 'Catalan Sheepdog',
      CAUCASIAN_SHEPHERD_DOG: 'Caucasian Shepherd Dog',
      CAVALIER_KING_CHARLES_SPANIEL: 'Cavalier King Charles Spaniel',
      CA_DE_BOU_PERRO_DE_PRESA: 'Ca de Bou (Perro de Presa)',
      CENTRAL_ASIAN_SHEPHERD_DOG: 'Central Asian Shepherd Dog',
      CESKY_TERRIER: 'Cesky Terrier',
      CHESAPEAKE_BAY_RETRIEVER: 'Chesapeake Bay Retriever',
      CHIHUAHUA: 'Chihuahua',
      CHINESE_CRESTED_DOG: 'Chinese Crested Dog',
      CHOW_CHOW: 'Chow Chow',
      CIRNECO_DELL_ETNA: 'Cirneco dell\'Etna',
      CLUMBER_SPANIEL: 'Clumber Spaniel',
      CONTINENTAL_TOY_SPANIEL: 'Continental Toy Spaniel',
      CORSICAN_DOG: 'Corsican Dog',
      COTON_DE_TULEAR: 'Coton de Tulear',
      CROATIAN_SHEEPDOG: 'Croatian Sheepdog',
      CURLYCOATED_RETRIEVER: 'Curly-Coated Retriever',
      CZECHOSLOVAKIAN_WOLFDOG: 'Czechoslovakian Wolfdog',
      DACHSHUND_LONGHAIRED: 'Dachshund (Long-haired)',
      DACHSHUND_LONGHAIRED_RABBIT: 'Dachshund (Long-haired rabbit)',
      DACHSHUND_SMOOTHHAIRED: 'Dachshund (Smooth-haired)',
      DACHSHUND_SMOOTHHAIRED_RABBIT: 'Dachshund (Smooth-haired rabbit)',
      DACHSHUND_WIREHAIRED: 'Dachshund (Wire-haired)',
      DACHSHUND_WIREHAIRED_RABBIT: 'Dachshund (Wire-haired rabbit)',
      DALMATIAN: 'Dalmatian',
      DANDIE_DINMONT_TERRIER: 'Dandie Dinmont Terrier',
      DOBERMAN_PINSCHER: 'Doberman Pinscher',
      DOGO_CANARIO: 'Dogo Canario',
      DOGUE_DE_BORDEAUX: 'Dogue de Bordeaux',
      DRENTSE_PARTRIDGE_DOG: 'Drentse Partridge Dog',
      DREVER: 'Drever',
      DUNKER: 'Dunker',
      DUPUY_POINTER: 'Dupuy Pointer',
      DUTCH_SHEPHERD_LONGHAIRED_VARIETY: 'Dutch Shepherd, Long-Haired Variety',
      DUTCH_SHEPHERD_ROUGHHAIRED_VARIETY: 'Dutch Shepherd, Rough-Haired Variety',
      DUTCH_SHEPHERD_SHORTHAIRED_VARIETY: 'Dutch Shepherd, Short-Haired Variety',
      DUTCH_SMOUSHOND: 'Dutch Smoushond',
      EAST_SIBERIAN_LAIKA: 'East Siberian Laika',
      ENGLISH_BULLDOG: 'English Bulldog',
      ENGLISH_COCKER_SPANIEL: 'English Cocker Spaniel',
      ENGLISH_POINTER: 'English Pointer',
      ENGLISH_SETTER: 'English Setter',
      ENGLISH_SPRINGER_SPANIEL: 'English Springer Spaniel',
      ENGLISH_TOY_TERRIER: 'English Toy Terrier',
      ENTLEBUCHER_MOUNTAIN_DOG: 'Entlebucher Mountain Dog',
      EURASIER: 'Eurasier',
      FAWN_BRITTANY_BASSET: 'Fawn Brittany Basset',
      FIELD_SPANIEL: 'Field Spaniel',
      FILA_BRASILEIRO: 'Fila Brasileiro',
      FINNISH_HOUND: 'Finnish Hound',
      FINNISH_LAPPHUND: 'Finnish Lapphund',
      FINNISH_SPITZ: 'Finnish Spitz',
      FLATCOATED_RETRIEVER: 'Flat-Coated Retriever',
      FOXHOUND_ENGLISH_FOXHOUND: 'Foxhound (English Foxhound)',
      FRENCH_BULLDOG: 'French Bulldog',
      FRENCH_SPANIEL: 'French Spaniel',
      FRENCH_WHITE_AND_BLACK_HOUND: 'French White and Black Hound',
      FRENCH_WHITE_AND_ORANGE_HOUND: 'French White and Orange Hound',
      FRISIAN_WATER_DOG: 'Frisian Water Dog',
      GASCONY_POINTER: 'Gascony Pointer',
      GERMAN_LONGHAIRED_POINTER: 'German Longhaired Pointer',
      GERMAN_PINSCHER: 'German Pinscher',
      GERMAN_SHEPHERD: 'German Shepherd',
      GERMAN_SHORTHAIRED_POINTER: 'German Shorthaired Pointer',
      GERMAN_SPITZ: 'German Spitz',
      GERMAN_WIREHAIRED_POINTER: 'German Wirehaired Pointer',
      GIANT_SCHNAUZER: 'Giant Schnauzer',
      GLEN_OF_IMAAL_TERRIER: 'Glen of Imaal Terrier',
      GOLDEN_RETRIEVER: 'Golden Retriever',
      GORDON_SETTER: 'Gordon Setter',
      GOTH_SHEPHERD_DOG: 'Goth Shepherd Dog',
      GRAND_ANGLOFRANCAIS_BLANC_ET_NOIR: 'Grand Anglo-Français Blanc et Noir',
      GRAND_ANGLOFRANCAIS_BLANC_ET_ORANGE: 'Grand Anglo-Français Blanc et Orange',
      GRAND_ANGLOFRANCAIS_TRICOLORE: 'Grand Anglo-Français Tricolore',
      GRAND_BASSET_GRIFFON_VENDEEN: 'Grand Basset Griffon Vendéen',
      GRAND_BLEU_DE_GASCOGNE: 'Grand Bleu de Gascogne',
      GRAND_GASCONSAINTONGEOIS_HOUND: 'Grand Gascon-Saintongeois Hound',
      GRAND_GRIFFON_VENDEEN: 'Grand Griffon Vendéen',
      GRAND_SPANISH_HOUND: 'Grand Spanish Hound',
      GREATER_SWISS_MOUNTAIN_DOG: 'Greater Swiss Mountain Dog',
      GREAT_DANE: 'Great Dane',
      GREAT_PYRENEES: 'Great Pyrenees',
      GREENLAND_DOG: 'Greenland Dog',
      GREYHOUND: 'Greyhound',
      HALDEN_HOUND: 'Halden Hound',
      HAMILTONSTOVARE: 'Hamiltonstövare',
      HANOVERIAN_SCENTHOUND: 'Hanoverian Scenthound',
      HANOVER_HOUND: 'Hanover Hound',
      HARRIER: 'Harrier',
      HAVANESE_DOG: 'Havanese (dog)',
      HELLENIC_HOUND: 'Hellenic Hound',
      HOKKAIDO: 'Hokkaido',
      HOVAWART: 'Hovawart',
      HUNGARIAN_GREYHOUND: 'Hungarian Greyhound',
      HUNGARIAN_KUVASZ: 'Hungarian Kuvasz',
      HYGEN_HOUND: 'Hygen Hound',
      IBIZAN_HOUND_SHORT_HAIRED: 'Ibizan Hound (short haired)',
      IBIZAN_HOUND_WIRE_HAIRED: 'Ibizan Hound (wire haired)',
      ICELANDIC_SHEEPDOG: 'Icelandic Sheepdog',
      IRISH_RED_AND_WHITE_SETTER: 'Irish Red and White Setter',
      IRISH_SETTER: 'Irish Setter',
      IRISH_TERRIER: 'Irish Terrier',
      IRISH_WATER_SPANIEL: 'Irish Water Spaniel',
      IRISH_WOLFHOUND: 'Irish Wolfhound',
      ISTRIAN_COARSEHAIRED_HOUND: 'Istrian Coarse-haired Hound',
      ISTRIAN_SHORTHAIRED_HOUND: 'Istrian Shorthaired Hound',
      ITALIAN_GREYHOUND: 'Italian Greyhound',
      ITALIAN_POINTING_DOG: 'Italian Pointing Dog',
      ITALIAN_SHORTHAIRED_HOUND: 'Italian Short-haired Hound',
      ITALIAN_SPITZ: 'Italian Spitz',
      ITALIAN_WIREHAIRED_HOUND: 'Italian Wire-haired Hound',
      JACK_RUSSELL_TERRIER: 'Jack Russell Terrier',
      JAGDTERRIER: 'Jagdterrier',
      JAPANESE_SPANIEL_CHIN: 'Japanese Spaniel (Chin)',
      JAPANESE_SPITZ: 'Japanese Spitz',
      JAPANESE_TERRIER: 'Japanese Terrier',
      KAI_KEN: 'Kai Ken',
      KARELIAN_BEAR_DOG: 'Karelian Bear Dog',
      KARST_SHEPHERD: 'Karst Shepherd',
      KERRY_BLUE_TERRIER: 'Kerry Blue Terrier',
      KISHU_KEN: 'Kishu Ken',
      KOMONDOR: 'Komondor',
      KOREAN_JINDO_DOG: 'Korean Jindo Dog',
      KROMFOHRLANDER: 'Kromfohrländer',
      KYILEO: 'Kyi-Leo',
      LABRADOR: 'Labrador',
      LAKELAND_TERRIER: 'Lakeland Terrier',
      LANDSEER: 'Landseer',
      LAPPONIAN_HERDER: 'Lapponian Herder',
      LARGE_MUNSTERLANDER: 'Large Münsterländer',
      LEONBERGER: 'Leonberger',
      LHASA_APSO: 'Lhasa Apso',
      LOWCHEN_LITTLE_LION_DOG: 'Lowchen (Little Lion Dog)',
      LUCERNE_HOUND: 'Lucerne Hound',
      LUZERNER_LAUFHUND: 'Luzerner Laufhund',
      MAJORCA_SHEPHERD_DOG: 'Majorca Shepherd Dog',
      MALTESE_DOG: 'Maltese (dog)',
      MANCHESTER_TERRIER: 'Manchester Terrier',
      MAREMMA_SHEEPDOG: 'Maremma Sheepdog',
      MASTIFF_FRENCH_MASTIFF: 'Mastiff (French Mastiff)',
      MEDIUM_POODLE: 'Medium Poodle',
      MEXICAN_HAIRLESS_DOG: 'Mexican Hairless Dog',
      MINIATURE_BULL_TERRIER: 'Miniature Bull Terrier',
      MINIATURE_DACHSHUND_LONGHAIRED: 'Miniature Dachshund (Long-haired)',
      MINIATURE_DACHSHUND_SMOOTHHAIRED: 'Miniature Dachshund (Smooth-haired)',
      MINIATURE_DACHSHUND_WIREHAIRED: 'Miniature Dachshund (Wire-haired)',
      MINIATURE_PINSCHER: 'Miniature Pinscher',
      MINIATURE_POODLE: 'Miniature Poodle',
      MINIATURE_SCHNAUZER: 'Miniature Schnauzer',
      MIXED_BREED_CROSSBREED: 'Mixed Breed (Crossbreed)',
      MUDI: 'Mudi',
      NEAPOLITAN_MASTIFF: 'Neapolitan Mastiff',
      NEWFOUNDLAND: 'Newfoundland',
      NORFOLK_TERRIER: 'Norfolk Terrier',
      NORRBOTTENSPETS: 'Norrbottenspets',
      NORWEGIAN_BUHUND: 'Norwegian Buhund',
      NORWEGIAN_ELKHOUND_BLACK: 'Norwegian Elkhound Black',
      NORWEGIAN_ELKHOUND_GRAY: 'Norwegian Elkhound Gray',
      NORWEGIAN_LUNDEHUND: 'Norwegian Lundehund',
      NORWICH_TERRIER: 'Norwich Terrier',
      NOVA_SCOTIA_DUCK_TOLLING_RETRIEVER: 'Nova Scotia Duck Tolling Retriever',
      OLD_DANISH_POINTER: 'Old Danish Pointer',
      OLD_ENGLISH_SHEEPDOG: 'Old English Sheepdog',
      OTTERHOUND: 'Otterhound',
      PARSON_RUSSELL_TERRIER: 'Parson Russell Terrier',
      PEKINGESE: 'Pekingese',
      PERUVIAN_HAIRLESS_DOG_LARGE: 'Peruvian Hairless Dog (Large)',
      PERUVIAN_HAIRLESS_DOG_MEDIUM: 'Peruvian Hairless Dog (Medium)',
      PERUVIAN_HAIRLESS_DOG_SMALL: 'Peruvian Hairless Dog (Small)',
      PETIT_BASSET_GRIFFON_VENDEEN: 'Petit Basset Griffon Vendéen',
      PETIT_BRABANCON: 'Petit Brabancon',
      PETIT_GASCON_SAINTONGEOIS: 'Petit Gascon Saintongeois',
      PHARAOH_HOUND: 'Pharaoh Hound',
      PICARDY_SHEPHERD: 'Picardy Shepherd',
      PICARDY_SPANIEL: 'Picardy Spaniel',
      POITEVIN: 'Poitevin',
      POLISH_HOUND: 'Polish Hound',
      POLISH_LOWLAND_SHEEPDOG: 'Polish Lowland Sheepdog',
      PONTAUDEMER_SPANIEL: 'Pont-Audemer Spaniel',
      PORCELAINE: 'Porcelaine',
      PORTUGUESE_PODENGO_GRANDE: 'Portuguese Podengo Grande',
      PORTUGUESE_PODENGO_MEDIO: 'Portuguese Podengo Medio',
      PORTUGUESE_PODENGO_PEQUENO: 'Portuguese Podengo Pequeno',
      PORTUGUESE_POINTER: 'Portuguese Pointer',
      PORTUGUESE_SHEEPDOG: 'Portuguese Sheepdog',
      PORTUGUESE_SHEEPDOG_LONGHAIRED: 'Portuguese Sheepdog (Long-haired)',
      PORTUGUESE_SHEEPDOG_SHORTHAIRED: 'Portuguese Sheepdog (Short-haired)',
      PORTUGUESE_WATER_DOG: 'Portuguese Water Dog',
      POSAVAC_HOUND: 'Posavac Hound',
      PRAGUE_RATTER: 'Prague Ratter',
      PUDEL_POINTER: 'Pudel Pointer',
      PUG: 'Pug',
      PULI_HUNGARIAN_SHEPHERD: 'Puli (Hungarian Shepherd)',
      PUMI_HUNGARIAN_SHEPHERD: 'Pumi (Hungarian Shepherd)',
      PYRENEAN_MOUNTAIN_DOG: 'Pyrenean Mountain Dog',
      PYRENEAN_POINTER: 'Pyrenean Pointer',
      PYRENEAN_SHEEPDOG_LONGFACED_VARIETY: 'Pyrenean Sheepdog, Long-Faced Variety',
      PYRENEAN_SHEEPDOG_SMOOTHFACED_VARIETY: 'Pyrenean Sheepdog, Smooth-Faced Variety',
      RAFEIRO_DE_ALENTEJO: 'Rafeiro de Alentejo',
      REDBONE_COONHOUND: 'Redbone Coonhound',
      REDTICK_COONHOUND: 'Redtick Coonhound',
      RHODESIAN_RIDGEBACK: 'Rhodesian Ridgeback',
      ROMAGNA_WATER_DOG: 'Romagna Water Dog',
      ROTTWEILER: 'Rottweiler',
      ROUGH_COLLIE: 'Rough Collie',
      RUSSIAN_BLACK_TERRIER: 'Russian Black Terrier',
      RUSSOEUROPEAN_LAIKA: 'Russo-European Laika',
      SAARLOOSWOLFHOND: 'Saarlooswolfhond',
      SAINTUSUGE_SPANIEL: 'Saint-Usuge Spaniel',
      SAINT_BERNARD: 'Saint Bernard',
      SALUKI: 'Saluki',
      SAMOYED: 'Samoyed',
      SANSHU: 'Sanshu',
      SCHAPENDOES: 'Schapendoes',
      SCHILLERSTOVARE: 'Schillerstövare',
      SCHIPPERKE: 'Schipperke',
      SCHWEIZER_LAUFHUND: 'Schweizer Laufhund',
      SCOTTISH_DEERHOUND: 'Scottish Deerhound',
      SCOTTISH_TERRIER: 'Scottish Terrier',
      SEALYHAM_TERRIER: 'Sealyham Terrier',
      SHAR_PEI: 'Shar Pei',
      SHETLAND_SHEEPDOG: 'Shetland Sheepdog',
      SHIBA_INU: 'Shiba Inu',
      SHIH_TZU: 'Shih Tzu',
      SHIKOKU: 'Shikoku',
      SHORTHAIRED_HUNGARIAN_POINTER: 'Short-haired Hungarian Pointer',
      SIBERIAN_HUSKY: 'Siberian Husky',
      SILKY_TERRIER: 'Silky Terrier',
      SKYE_TERRIER: 'Skye Terrier',
      SLOUGHI: 'Sloughi',
      SLOVAKIAN_WIREHAIRED_POINTER: 'Slovakian Wirehaired Pointer',
      SLOVAK_CUVAC: 'Slovak Cuvac',
      SLOVAK_HOUND: 'Slovak Hound',
      SMALAND_HOUND: 'Smaland Hound',
      SMALL_MUNSTERLANDER: 'Small Munsterlander',
      SMALL_SPANISH_HOUND: 'Small Spanish Hound',
      SMOOTH_COLLIE: 'Smooth Collie',
      SMOOTH_FOX_TERRIER_ENGLISH_FOX_TERRIER: 'Smooth Fox Terrier (English Fox Terrier)',
      SOFTCOATED_WHEATEN_TERRIER: 'Soft-coated Wheaten Terrier',
      SOUTH_RUSSIAN_OVCHARKA: 'South Russian Ovcharka',
      SPANISH_GREYHOUND_GALGO_ESPANOL: 'Spanish Greyhound (Galgo Español)',
      SPANISH_MASTIFF: 'Spanish Mastiff',
      SPANISH_WATER_DOG: 'Spanish Water Dog',
      SPINONE_ITALIANO: 'Spinone Italiano',
      STABYHOUN: 'Stabyhoun',
      STAFFORDSHIRE_BULL_TERRIER: 'Staffordshire Bull Terrier',
      STANDARD_POODLE: 'Standard Poodle',
      STANDARD_SCHNAUZER: 'Standard Schnauzer',
      STICHELHAAR: 'Stichelhaar',
      STYRIAN_COARSEHAIRED_HOUND: 'Styrian Coarse-haired Hound',
      ST_GERMAIN_POINTING_DOG: 'St. Germain Pointing Dog',
      SUSSEX_SPANIEL: 'Sussex Spaniel',
      SWEDISH_ELKHOUND: 'Swedish Elkhound',
      SWEDISH_LAPPHUND: 'Swedish Lapphund',
      TATRA_MOUNTAIN_SHEEPDOG: 'Tatra Mountain Sheepdog',
      TECKEL_DE_CHASSE_AU_LAPIN_POIL_DUR: 'Teckel de Chasse au lapin (poil dur)',
      TIBETAN_MASTIFF: 'Tibetan Mastiff',
      TIBETAN_SPANIEL: 'Tibetan Spaniel',
      TIBETAN_TERRIER: 'Tibetan Terrier',
      TOSA: 'Tosa',
      TOY_POODLE: 'Toy Poodle',
      TRICOLOUR_HOUND: 'Tricolour Hound',
      TYROLEAN_HOUND: 'Tyrolean Hound',
      WACHTELHUND: 'Wachtelhund',
      WEIMARANER_LONGHAIRED: 'Weimaraner Long-haired',
      WEIMARANER_SHORTHAIRED: 'Weimaraner Short-haired',
      WELSH_CORGI_CARDIGAN: 'Welsh Corgi (Cardigan)',
      WELSH_CORGI_PEMBROKE: 'Welsh Corgi (Pembroke)',
      WELSH_SPRINGER_SPANIEL: 'Welsh Springer Spaniel',
      WELSH_TERRIER: 'Welsh Terrier',
      WESTPHALIAN_DACHSBRACKE: 'Westphalian Dachsbracke',
      WEST_HIGHLAND_WHITE_TERRIER: 'West Highland White Terrier',
      WEST_SIBERIAN_LAIKA: 'West Siberian Laika',
      WHIPPET: 'Whippet',
      WHITE_SWISS_SHEPHERD_DOG: 'White Swiss Shepherd Dog',
      WIREHAIRED_HUNGARIAN_POINTER: 'Wire-haired Hungarian Pointer',
      WIREHAIRED_POINTING_GRIFFON: 'Wirehaired Pointing Griffon',
      WIRE_FOX_TERRIER: 'Wire Fox Terrier',
      YORKSHIRE_TERRIER: 'Yorkshire Terrier',
      YUGOSLAVIAN_MOUNTAIN_HOUND: 'Yugoslavian Mountain Hound',
      YUGOSLAVIAN_SHEPHERD_DOG: 'Yugoslavian Shepherd Dog',
      YUGOSLAVIAN_TRICOLOUR_HOUND: 'Yugoslavian Tricolour Hound'
    }
  },
  cancellation: {
    no_use_transfer_cta_primary: 'I offer my tracker',
    no_use_transfer_cta_secondary: 'Cancel anyway',
    no_use_transfer_info: 'Your relative must first create a Weenect account. It is free, with no subscription or tracker purchase required. Inform them to speed up the transfer.',
    no_use_transfer_subtitle: 'Another animal could benefit! Give it to a loved one: they will receive one month of free subscription. On your side, your subscription will be canceled and you will no longer be charged.',
    no_use_transfer_title: 'What if you gave your tracker to a loved one?'
  },
  changePaymentMean: {
    ADD_BANK_ACCOUNT: 'Add an account to be charged',
    ADD_BANK_CARD: 'Pay by card',
    BANK_ACCOUNT_ERROR: 'There was a problem changing your banking details. Please contact customer services.',
    BANK_ACCOUNT_EXPLANATION: 'Note that none of your bank information are saved in our servers.',
    BANK_ACCOUNT_SUCCESS: 'Banking details successfully updated',
    BANK_CARD_ERRORED: 'Issue during means of payment update. Please contact the <1>after sale service</1>.',
    BANK_CARD_UPDATED: 'Credit card updated',
    CAPTATION: 'To update your bank details, we are going to authorise a charge on your card of {{ amount }}.',
    CAPTATION_EXPLANATION1: 'This amount will not be taken. The transaction is cancelled immediately.',
    CAPTATION_EXPLANATION2: 'This procedure allows us to comply with Internet payment standards and ensure the safety of your bank details. None of this information will pass through our servers.',
    CAPTATION_EXPLANATION3: 'IMPORTANT : the debit form will be named under "Hareau" and not "Weenect". That is normal, as this is the name of our company. "Weenect" being the trade name.',
    CAPTATION_EXPLANATION4: 'Update your bank details while maintaining you subscription.',
    CARD_AUTHORIZED: 'We accept payments by:',
    CHANGE_PAYMENT_MEAN: 'Update credit card',
    CURRENT_CHOICE_CB: 'You chose to pay by credit card.',
    CURRENT_CHOICE_IBAN: 'You chose to pay by IBAN',
    CURRENT_MEAN: 'Current payment method',
    CURRENT_MEAN_PHRASE: 'You have chosen to pay by credit card',
    CURRENT_MEAN_PHRASE_GOCARDLESS: 'You have chosen to pay by short code',
    DEFAULT_MEAN: 'Default payment method:',
    GO_TO_SEPA: 'Switch to direct debit',
    MODIFY: 'Modify means of payment',
    TITLE: 'Means of payment',
    UPDATE_BANK_ACCOUNT: 'Modify account to debit',
    UPDATE_BANK_CARD: 'Update credit card',
    USED_PAYMENT_EXPLANATION: 'This payment method is used to pay for your subscriptions and options.'
  },
  change_password: {
    warning_logout_all: 'For your security, changing your password will log you out of all your devices. You will need to log in again with the new password.'
  },
  commonActions: {
    ACTIVATE: 'Activate',
    BACK: 'Back',
    CANCEL: 'Cancel',
    CAN_BE_CANCELED: 'You can cancel at any time.',
    CHANGE: 'Save',
    CONFIGURE: 'Set up',
    DEACTIVATE: '',
    GO_MAP: 'Go to the map',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'A problem occurred'
    },
    NEXT: 'Next',
    NO: 'No',
    OK: 'OK',
    REGISTER: 'Activate',
    SAVE: 'Save',
    SELECT_ALL: 'Select all',
    SEND: 'Send',
    SUBSCRIBE: 'Sign up',
    THEN: 'then',
    UNSELECT_ALL: 'Unselect all',
    UPDATE: 'Save',
    VALIDATE: 'Confirm',
    YES: 'Yes'
  },
  creditCardAlert: {
    AUTO_RENEWAL_ADVICE: 'If you want to continue using your tracker, please add a new payment method now.',
    AUTO_RENEWAL_NOTICE: 'Warning! Your subscription is about to expire and your credit card has expired.'
  },
  emailPreferences: {
    EMAIL_LISTS: {
      COMPANY_NEWS: 'Company news',
      NEW_FEATURES: 'New features',
      OFFERS: 'Promotional offers',
      SERVICE_STATUS: 'Service failures and updates',
      SURVEYS_AND_TESTS: 'Surveys and Beta tests',
      TUTORIALS: 'Tutorials'
    },
    EMAIL_LISTS_HEADER: 'Email list',
    EMAIL_LISTS_INFO: {
      SERVICE_STATUS: 'Necessary for the proper functioning of the service.'
    },
    ENGAGEMENT_NOTIFICATIONS_CHECKBOX: 'I want to receive notifications with tips on using the mobile app',
    ENGAGEMENT_NOTIFICATIONS_DESCRIPTION: 'These notifications will help you get the most out of the mobile app by offering usage tips.',
    ENGAGEMENT_NOTIFICATIONS_TITLE: 'Usage tips',
    LANGUAGE_PREFERENCES_DESCRIPTION: 'Choose the language in which you want to receive emails:',
    OPEN_TRACKING_CHECKBOX_TEXT: 'I accept the tracking of my email openings',
    OPEN_TRACKING_DESCRIPTION: 'Tracking opens helps us measure the effectiveness of our communications and adjust the frequency and content of our emails.',
    OPEN_TRACKING_HEADLINE: 'Email open tracking',
    PREFERENCES_DECRIPTION: 'Choose the type of emails you want to receive. We will only send you the ones that match your choices. '
  },
  error: {
    TITLE: 'Oops a problem has occurred '
  },
  errors: {
    DEFAULT: 'Invalid field',
    FIELD_REQUIRED: 'This field is required',
    GENERAL: 'An error has occurred, please try again',
    IMEI: 'Enter a valid IMEI number',
    MAIL_FORMAT: 'This email format is invalid',
    MAX_LENGTH: 'The field can contain up to 15 characters',
    PASSWORD_FORMAT: 'Your password must contain at least one digit, one uppercase letter, and one lowercase letter.',
    PHONE_FORMAT: 'The phone number must include the international prefix',
    PROMO_CODE: 'Invalid promo code'
  },
  forgotPassword: {
    FORGOT_PASSWORD_BUTTON: 'Send me a reset password link',
    FORGOT_PASSWORD_CANCEL: 'Back to login',
    FORGOT_PASSWORD_ERRORS: {
      UNKNOWN: 'An error occured. Contact our customer help.'
    },
    FORGOT_PASSWORD_EXPIRED: 'Your password reset link has expired.',
    FORGOT_PASSWORD_RETRY: 'Ask for a new forgot password link',
    FORGOT_PASSWORD_SUCCESS: 'If an account is attached to the {{mail}} address, you will receive an email with a link to reset your password.'
  },
  forgotpassword: {
    BACK_TO_LOGIN_CTA: 'Back to login',
    CONFIRMATION_SUBTITLE: 'If there is an account associated with the address {{email}}, you will receive an email with a link to reset your password.',
    CONFIRMATION_TITLE: 'Email sent!',
    EMAIL_CONFIRM_PLACEHOLDER: 'Confirm email address',
    EMAIL_PLACEHOLDER: 'Email address',
    SUBMIT_CTA: 'Receive forgot password link',
    SUBTITLE: 'Enter your email address to receive a reset link.',
    TITLE: 'Forgot password?'
  },
  forms: {
    CITY: {
      LABEL: 'Town/City',
      PLACEHOLDER: 'Your town/city'
    },
    CONFIRM_PASSWORD: {
      LABEL: 'Repeat Password',
      PLACEHOLDER: 'Confirm'
    },
    COUNTRY: {
      LABEL: 'Country'
    },
    EMAIL: {
      LABEL: 'Email address',
      PLACEHOLDER: 'votre@email.com'
    },
    FIRST_NAME: {
      LABEL: 'First name',
      PLACEHOLDER: 'Your first name'
    },
    LANGUAGE: {
      LABEL: 'Language'
    },
    LAST_NAME: {
      LABEL: 'Last name',
      PLACEHOLDER: 'Your last name'
    },
    NEW_PASSWORD: {
      LABEL: 'New password',
      PLACEHOLDER: 'Your new password'
    },
    OLD_PASSWORD: {
      LABEL: 'Old password',
      PLACEHOLDER: 'Your old password'
    },
    PASSWORD: {
      LABEL: 'Password',
      PLACEHOLDER: 'Password',
      VALIDATION: 'Your password must be at least 8 characters long.',
      WARNING: 'Warning, "qwertyuiop" and "123456789" are NOT strong security passwords.\nCheck the level of security of your password here : <1>https://howsecureismypassword.net</1>'
    },
    PHONE: {
      LABEL: 'Telephone',
      PLACEHOLDER: '+33600000000'
    },
    POSTAL_CODE: {
      LABEL: 'ZIP code',
      PLACEHOLDER: 'Your postcode',
      STREET_NUMBER: 'Street number and name'
    },
    STREET: {
      LABEL: 'Address',
      PLACEHOLDER: 'Number and name of street'
    }
  },
  general: {
    ALERT_ZONES: 'Alert zones',
    BACK_BUTTON: 'Back',
    DISABLED: 'Disabled',
    EMAIL: 'Email',
    ENABLED: 'Enabled',
    ENERGY_SAVING_ZONES: 'Power-saving areas',
    ERROR_FORMAT: 'Sorry, this format is not valid',
    ERROR_MISMATCH: 'Both fields must match',
    ERROR_NETWORK: 'An unexpected error occurred. Please try again.',
    ERROR_PAGE_TITLE: 'Oops, something went wrong.',
    FROM: 'From',
    HISTORY: 'History',
    LOGOUT_MENU_DISCONNECT: 'Logout',
    MOBILE_ONLY_SETTINGS_NOTE: 'You can change these settings anytime in the Weenect mobile app.',
    NONE: 'None',
    NOTIFICATIONS: 'Notifications',
    OPEN: 'Open',
    PUSH: 'Push',
    SAFETY_ZONES: 'Safety areas',
    SMS: 'SMS',
    TO: 'To',
    TRACKER_PROFILE: 'Tracker profile',
    password_length: 'Your password must be at least 8 characters long.',
    save_button: 'Save'
  },
  general_password_length: 'Your password must be at least 8 characters long.',
  geofences: {
    CREATE: {
      HEADLINE: 'Create an area'
    },
    EDIT: {
      DELETE_GEOFENCE: 'Delete area',
      ENTRANCE_NOTIFICATION: 'Geofence entrance notification',
      EXIT_NOTIFICATION: 'Geofence exit notification',
      GEOCODE_LABEL: 'Use an address',
      GEOCODE_PLACEHOLDER: 'Enter the address here',
      LOCATION: 'Centre of the geofence',
      NAME_INPUT: {
        LABEL: 'Area name',
        PLACRHOLDER: 'Enter geofence name'
      },
      OUTDOORS: 'Outdoor area (park forest)',
      OUTDOORS_TOOLTIP: 'Since GPS is more accurate outdoors, the rules for triggering an entry or exit notification are distinct for an internal area and an external area.',
      POINT_ON_THE_MAP_TEXT: 'or click directly on the map',
      RADIUS: 'Geofence size (radius in metres)',
      TRACKER_LAST_POSITION_BUTTON: 'Use the tracker position',
      UNKNOWN_ADDRESS: 'Unknown address'
    }
  },
  header: {
    ALL_TRACKERS: 'All trackers',
    AVAILABLE_PLURAL: 'available',
    NAV: {
      ACCOUNT: 'Account',
      INSURANCE: 'Insurance',
      LOGOUT: 'Logout',
      SUPPORT: 'Support',
      TRACKERS: 'Map'
    },
    SEARCHBAR_RESULT: 'trackers found',
    SEARCHBAR_TITLE: 'Search for a tracker:',
    TRACKERS: 'tracker(s)',
    WHITE_LABEL: {
      IN_PARTERNSHIP_WITH: 'In partnership with'
    }
  },
  history: {
    DATE_SELECTOR_LABEL: 'Select a day to display',
    MARKER_END: 'End',
    MARKER_START: 'Start',
    PLAYBACK_BUTTON: 'Pause',
    PLAYBACK_POSITION: 'Position {{index}} / {{total}}',
    PLAYBACK_TIME_LABEL: 'Duration',
    PLAY_CTA: 'Start',
    POINT_BATTERY_LABEL: 'Battery:',
    POINT_POSITION_LABEL: 'Position:',
    POINT_TIME_LABEL: 'Time:',
    RANGE_SLIDER_LABEL: 'Use the slider to select the period to display:',
    STATS_DISTANCE_LABEL: 'Total distance',
    STATS_DURATION_LABEL: 'Duration',
    STATS_SPEED_AVG_LABEL: 'Avg. speed',
    STATS_SPEED_MAX_LABEL: 'Max speed',
    STATS_TITLE: 'Activity details',
    STOP_CTA: 'STOP',
    TIMEFRAME_12H: '12 h',
    TIMEFRAME_1H: '1 h',
    TIMEFRAME_24H: '24 h',
    TIMEFRAME_3H: '3 h',
    TIMEFRAME_6H: '6 h',
    TIMEFRAME_LABEL: 'Show the latest'
  },
  home: {
    ACCOUNT_CARD_TITLE: 'My account',
    ADD_TRACKER_CTA: 'Add a tracker',
    AI_ASSISTANT_ITEM: 'AI assistant',
    ALERT_ZONES_ITEM: 'Alert zones',
    CONTACT_FORM_ITEM: 'Contact form',
    ENERGY_ZONES_ITEM: 'Power-saving areas',
    GREETING: 'Hello {{firstname}}',
    HELP_CARD_TITLE: 'Need help?',
    HELP_CENTER_ITEM: 'Help center',
    HISTORY_CARD_TITLE: 'History',
    MANAGE_SUBSCRIPTION_CTA: 'Manage my subscription',
    MAP_CARD_TITLE: 'Map',
    NOTIFICATIONS_ITEM: 'Notifications',
    PASSWORD_ITEM: 'Password',
    PAYMENT_METHOD_CTA: 'Payment method and invoices',
    PREFERENCES_ITEM: 'Preferences',
    SUBSCRIPTION_BANNER_LABEL: 'SUBSCRIPTION FOR TRACKER {{name}}',
    SUBSCRIPTION_LABEL: 'Subscription {{duration}}',
    SUBSCRIPTION_LABEL_NO_SUBSCRIPTION: 'No subscription',
    SUB_GREETING: 'Welcome to your Weenect space',
    TRACKER_PROFILE_ITEM: 'Tracker profile',
    TRACKER_SELECTOR_LABEL: 'My trackers',
    TRACKER_SETTINGS_CARD_TITLE: 'Tracker settings',
    USER_PROFILE_ITEM: 'User profile'
  },
  imeiInfo: {
    HINT: 'You will find the IMEI number on the back of your tracker.',
    IMAGE_ALT: 'Photo of the tracker',
    TITLE: 'IMEI number'
  },
  login: {
    EMAIL_PLACEHOLDER: 'Email address',
    ERROR_INVALID_CREDENTIALS: 'Invalid password.',
    FORGOT_PASSWORD: 'Forgot your password?',
    FORGOT_PASSWORD_LINK: 'Forgot password?',
    LOGIN_ERRORS: {
      UNKNOWN: 'Login failure'
    },
    PASSWORD_PLACEHOLDER: 'Password',
    REGISTER_CTA: 'Create a free account',
    REGISTER_PROMPT_TITLE: 'No account yet?',
    SIGN_IN_BUTTON: 'Login',
    SIGN_IN_HEADLINE: 'Login',
    SIGN_UP_BUTTON: 'Create an account',
    SIGN_UP_HEADLINE: 'Don\'t have an account yet?',
    SUBMIT_CTA: 'Login',
    TERMS_LINK: 'Terms and conditions of use',
    TERMS_LINK_URL: 'https://www.weenect.com/common/pdf/en/cgv-weenect.pdf',
    TITLE: 'Login'
  },
  manageSubscription: {
    CANCEL: {
      DESCRIBE_YOUR_PROBLEMS: 'Could you please describe your reason for ending your subscription?',
      GIVE_US_DETAILS: 'Reason for ending your subscription.',
      REASONS: {
        AFTER_SALES_SERVICE: 'Bad experience with Customer Services',
        BATTERY: 'Battery life too short',
        LOST_BROKEN: 'I\'ve lost / broke it',
        MOBILE_APPLICATION: 'The app doesn\'t work',
        NOT_SATISFIED: 'I\'m not satisfied with Weenect',
        NO_USE: 'I don\'t need it anymore',
        TOO_EXPENSIVE: 'The subscription is too expensive',
        TRACKER_FORMAT: 'Tracker needs to be redesigned (size and weight)',
        WILL_REACTIVATE_LATER: 'I\'m going to reactivate the subscription later'
      },
      SAD_TO_SEE_YOU_LEAVE: 'We are sorry to see you leave.',
      WHY_DO_YOU_RESIGN: 'For what reason do you wish to cancel your subscription?'
    },
    CANCEL_EXPIRE: 'Automatic renewal has been cancelled. The subscription will expire on {{date}}.',
    CANCEL_QUESTION: 'Do you want to discontinue the subscription?',
    CANCEL_RENEWAL: 'Cancel automatic renewal',
    CANCEL_RENEWAL_BIS: 'Unsubscribe',
    CANT_RESIGN_UNDER_EXTENDED_NOTICE: 'Want to end your subscription or simply stop it renewing automatically?\nCall us on +33 (0)1 87 66 98 71 between 9:30 a.m. and 4 p.m. Monday to Friday.',
    CANT_RESIGN_UNDER_NOTICE: 'It is not possible to cancel your subscription in the final 30 days. Please contact the Customer Support team.',
    CANT_RESIGN_UNTIL: 'You can\'t resign your subscription until the {{date}}',
    CANT_RESIGN_WHILE_COMMITED: 'You are committed for 3 months, the termination of your subscription will only take effect at the end of the current period, i.e. on {{date}}',
    CURRENT_PLAN: 'Current subscription',
    HEADLINE: 'Manage subscription',
    MESSAGES: {
      UPDATE_SUCCESS: 'Subscription successfully updated.'
    },
    RENEW_SUBSCRIPTION: 'Renew subscription',
    RESIGN_DATE: 'The termination of your subscription will take effect at the end of the current period on {{date}}',
    RESUMPTION_DATE: 'Choose a resumption date',
    RETURN_TO_TRACKERS: 'Back to the map'
  },
  map: {
    ERROR_BANNER_MESSAGE: 'An error occurred. Please try again.',
    FLASHLIGHT_DURATION_10_MIN: '10 min',
    FLASHLIGHT_DURATION_1_MIN: '1 min',
    FLASHLIGHT_DURATION_2_MIN: '2 min',
    FLASHLIGHT_DURATION_30_MIN: '30 min',
    FLASHLIGHT_DURATION_5_MIN: '5 min',
    FLASHLIGHT_MODE_FLASHING: 'Blinking',
    FLASHLIGHT_MODE_STEADY: 'Continuous',
    FLASHLIGHT_TITLE: 'Flashlight',
    GPS_IN_WIFI_ZONE: 'In a Wi-Fi zone',
    IMMOBILE_FOR_DAY: 'Still for 1 day',
    IMMOBILE_FOR_DAYS: 'Still for {{time}} days',
    IMMOBILE_FOR_HOUR: 'Still for 1 hour',
    IMMOBILE_FOR_HOURS: 'Still for {{time}} hours',
    IMMOBILE_FOR_MINUTE: 'Still for 1 minute',
    IMMOBILE_FOR_MINUTES: 'Still for {{time}} minutes',
    IMMOBILE_SINCE: 'Still since {{date}}',
    LAST_COMMUNICATION_AGO: 'Last communication {{time}} ago',
    LAST_COMMUNICATION_ON: 'Last communication on {{date}}',
    MAP_SELECTOR_MAP: 'Map',
    MAP_SELECTOR_MAP_3D: '3D Map',
    MAP_SELECTOR_MAP_HD: 'HD Map',
    MAP_SELECTOR_PREMIUM_MAPS_TITLE: 'Premium maps',
    MAP_SELECTOR_SATELLITE: 'Satellite',
    MAP_SELECTOR_SATELLITE_3D: '3D Satellite',
    MAP_SELECTOR_SATELLITE_HD: 'HD Satellite',
    MAP_SELECTOR_STANDARD_MAPS_TITLE: 'Standard maps',
    MAP_SELECTOR_TERRAIN: 'Relief',
    MAP_SELECTOR_TRAILS: 'Paths and trails',
    NO_GPS_MARKER_TITLE: 'Invalid GPS',
    NO_POSITION: 'No known position',
    ON_DATE: 'on {{date}}',
    POSITION: 'Position',
    POSITION_RECEIVED_DAYS_AGO: 'Position received {{time}} days ago',
    POSITION_RECEIVED_DAY_AGO: 'Position received 1 day ago',
    POSITION_RECEIVED_HOURS_AGO: 'Position received {{time}} hours ago',
    POSITION_RECEIVED_HOUR_AGO: 'Position received 1 hour ago',
    POSITION_RECEIVED_MINUTES_AGO: 'Position received {{time}} minutes ago',
    POSITION_RECEIVED_MINUTE_AGO: 'Position received 1 minute ago',
    POSITION_RECEIVED_ON: 'Position received on {{date}}',
    POSITION_RECEIVED_SECONDS_AGO: 'Position received {{time}} seconds ago',
    POSITION_RECEIVED_SECOND_AGO: 'Position received {{time}} second ago',
    REFRESH_FAILED: 'Position update failed.',
    REFRESH_MULTI_TRACKER_SENT: 'Position update requests sent.',
    REFRESH_SINGLE_TRACKER_SENT: 'Position update request sent.',
    REFRESH_SUCCEEDED: 'Position has been updated.',
    RING_DURATION_10_SECONDS: '10 s',
    RING_DURATION_1_SECOND: '1 s',
    RING_DURATION_30_SECONDS: '30 s',
    RING_DURATION_3_SECONDS: '3 s',
    RING_DURATION_5_SECONDS: '5 s',
    RING_TITLE: 'Ringing',
    STATUS_GOOD: 'Good',
    STATUS_LOW: 'Low',
    STATUS_MEDIUM: 'Medium',
    SUPERLIVE_DURATION_10_MIN: '10 min',
    SUPERLIVE_DURATION_1_MIN: '1 min',
    SUPERLIVE_DURATION_2_MIN: '2 min',
    SUPERLIVE_DURATION_30_MIN: '30 min',
    SUPERLIVE_DURATION_5_MIN: '5 min',
    SUPERLIVE_INFO: 'Note: The tracker’s actual position will take a few seconds to refresh after activating Superlive.',
    SUPERLIVE_STOP: 'STOP',
    SUPERLIVE_TIMER_LABEL: 'Time',
    SUPERLIVE_TITLE: 'Superlive',
    TIME_AGO_DAY: '1 day ago',
    TIME_AGO_DAYS: '{{time}} days ago',
    TIME_AGO_HOUR: '1 hour ago',
    TIME_AGO_HOURS: '{{time}} hours ago',
    TIME_AGO_MINUTE: '1 minute ago',
    TIME_AGO_MINUTES: '{{time}} minutes ago',
    TIME_AGO_SECOND: '{{time}} second ago',
    TIME_AGO_SECONDS: '{{time}} seconds ago',
    TRACKER_MODE_ACTIVE_GPS_REPORT: 'GPS update: 30 s',
    TRACKER_MODE_ACTIVE_LABEL: 'Active',
    TRACKER_MODE_ACTIVE_PLUS_GPS_REPORT: 'GPS update: 10 s',
    TRACKER_MODE_ACTIVE_PLUS_LABEL: 'Active Plus',
    TRACKER_MODE_ECO_GPS_REPORT: 'GPS update: 5 min',
    TRACKER_MODE_ECO_LABEL: 'Eco',
    TRACKER_MODE_ECO_PLUS_GPS_REPORT: 'GPS update: disabled',
    TRACKER_MODE_ECO_PLUS_LABEL: 'Eco Plus',
    TRACKER_MODE_EDIT_ON_MOBILE_NOTICE: 'Tracker mode changes are made directly from the Weenect mobile app.',
    TRACKER_MODE_SMART_GPS_REPORT: 'GPS update: 1 min',
    TRACKER_MODE_SMART_LABEL: 'Smart',
    TRACKER_MODE_TITLE: 'Tracker mode',
    TRACKER_SIDEBAR_AVAILABLE_TRACKERS_COUNT: '{{number}} trackers available',
    TRACKER_SIDEBAR_BATTERY_LABEL: 'Battery',
    TRACKER_SIDEBAR_GPS_SIGNAL_LABEL: 'GPS signal',
    TRACKER_SIDEBAR_LAST_COMMUNICATION_LABEL: 'Last communication',
    TRACKER_SIDEBAR_MULTI_TRACKER_VIEW: 'Multi-tracker view',
    TRACKER_SIDEBAR_NETWORK_LABEL: 'Network',
    TRACKER_SIDEBAR_NO_KNOWN_POSITION: 'No known position',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_CTA: 'Subscribe to a subscription',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_STATE: 'No active subscription',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_TITLE: 'You do not have an active subscription for this tracker',
    TRACKER_SIDEBAR_OTHER_TRACKERS_TITLE: 'Other trackers',
    TRACKER_SIDEBAR_POWER_UP_NEXT: 'Next',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_BODY: 'The tracker must be outside or near a window during the get started phase.',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_BUTTON: 'I have turned on my tracker',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_TITLE: 'Press the center button for 3 seconds to turn on your tracker.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_BODY: 'The first login can take up to 5 minutes. You do not need to do anything.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_HINT: 'Wait until the green LED stays on then turns off.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_TITLE: 'Your tracker is now trying to connect to the network.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_BODY: 'Place the tracker outside, front facing the sky, to help find GPS positions.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_HINT: 'Please wait, the tracker is locating its position.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_TITLE: 'Now that it is connected, your tracker is trying to capture GPS signals.',
    TRACKER_SIDEBAR_TITLE: 'My trackers',
    TRACKER_SIDEBAR_TRACKER_STATE_LABEL: 'Tracker status',
    TRACKER_STATE_AIRPLANE_MODE: 'In airplane mode',
    TRACKER_STATE_BATTERY_EMPTY: 'No more battery',
    TRACKER_STATE_CONNECTED: 'Tracker connected',
    TRACKER_STATE_DISCONNECTED: 'Tracker disconnected',
    TRACKER_STATE_GSM_UNREACHABLE: 'Out of GSM network',
    TRACKER_STATE_MANUALLY_OFF: 'Manually turned off',
    TRACKER_STATE_POWER_SAVING_AREA: 'In power saving mode',
    TRACKER_STATE_SUBSCRIPTION_EXPIRED: 'You do not have a subscription',
    VIBRATION_DURATION_10_SECONDS: '10 s',
    VIBRATION_DURATION_1_SECOND: '1 s',
    VIBRATION_DURATION_30_SECONDS: '30 s',
    VIBRATION_DURATION_3_SECONDS: '3 s',
    VIBRATION_DURATION_5_SECONDS: '5 s',
    VIBRATION_RING_INFO: 'Good to know: Train your pet to come when called by associating the ringing or buzzer with their meal.',
    VIBRATION_TITLE: 'Vibration'
  },
  mapControls: {
    MAP_TYPE: 'Map type',
    REFRESH_POSITION: 'Refresh position',
    SUPER_LIVE: 'Superlive',
    ZOOM_IN: 'Zoom +',
    ZOOM_OUT: 'Zoom -'
  },
  mapLayers: {
    CLASSIC_MAPS: 'Free maps',
    DONT_SUBSCRIBE: 'Continue with standard maps',
    FOREST_PATH: 'Paths and trails',
    GOOGLE_STREET: 'Google Maps',
    GRAY: 'Black and white',
    PLAN: 'Map',
    PREMIUM_MAPS: 'Premium maps',
    PREMIUM_SUBSCRIBE: 'Subscribe to the Premium Maps option',
    PREMIUM_WARNING_MSG: '<1>Oops, you are not currently subscribed to the Premium Maps option!</1>\n\nThe Premium Maps option gives you the advantage of more comprehensive and regularly updated maps that allow you to better see and monitor your tracker\'s movements. \u2028Offering HD Satellite, Terrain Map and Forest Trails versions, it enables you to find your tracker\'s current location at a glance.\n\nSubscribe to this option for just {{mapOptionPrice}} per month!',
    RELIEF: 'Reliefs',
    SATELLITE: 'Satellite',
    STREET: 'Classic',
    UNLOCK_MAPS: 'Unlock the additional cards by clicking on them!'
  },
  misc: {
    LANGUAGE: {
      DE: 'German',
      EN: 'English',
      ES: 'Spanish',
      FR: 'French',
      IT: 'Italian',
      NL: 'Dutch'
    },
    NO_DATE: 'No known position',
    ROTATE_DEVICE: 'Weenect was designed to be used in portrait mode. Please rotate your device for best use of our services.',
    locale: 'en-US'
  },
  newpassword: {
    EXPIRED_LINK_LINK: 'Request a new forgotten password link',
    EXPIRED_LINK_TEXT: 'This link has expired. Please request a new password reset.',
    NEWPASSWORD_CONFIRMATION_PLACEHOLDER: 'Password Confirmation',
    NEWPASSWORD_PLACEHOLDER: 'New Password',
    SCREEN_TITLE: 'New Password'
  },
  onboarding: {
    ACTIVATING_HINT: 'Average activation time is 5 minutes',
    ACTIVATING_INDICATOR: 'Activation in progress',
    GREET: {
      BUTTON: 'My tracker is on.',
      COMMON_TEXT: 'To get a good start we recommend that you follow this tutorial. It will help you get started with your tracker.\n\nLet\'s start with switching on your tracker. Follow the directions below to turn it on:',
      MAIN_TITLE: 'Contact information',
      RED_TEXT: 'The tracker needs to be outdoors in order for it to obtain a GPS location.'
    },
    MAP_INTERACTIONS: {
      COMMON_TEXT: {
        PET: 'From top to bottom, these buttons allow you to make your tracker ring or vibrate. These features allow you to train your pet to come when called.',
        SILVER: 'From top to bottom, these buttons allow you to make your tracker ring or vibrate. '
      },
      TITLE: 'The buttons that interact with the tracker'
    },
    MAP_INTERVAL: {
      COMMON_TEXT: 'This button allows you to select how often you want to receive a new GPS location for your tracker. Please note, the shorter the interval, the less time the battery of the tracker will last.',
      TITLE: 'The GPS reporting time interval'
    },
    MAP_OPTIONS: {
      COMMON_TEXT: 'These buttons allow you to change the type of map on display and zoom in or out on the map.',
      TITLE: 'Map adjustment buttons'
    },
    MAP_UPDATE: {
      COMMON_TEXT: 'This button allows you to update the location of your tracker (to obtain a new location your tracker must be connected to the server and have a valid GPS signal).',
      TITLE: 'The position refresh button'
    },
    MODAL: {
      BUTTON_HINT: 'Press the button for 3 seconds until the tracker vibrates.',
      HEADLINE: 'Turn on your tracker outdoors or on a window sill',
      IMAGE_ALT: 'Photo of the tracker',
      MAP_HINT: 'Once turned on, the tracker will usually be displayed on the map within 5 minutes.'
    },
    REMOTE_ASSISTANCE: {
      ASSISTANCE: {
        COMMON_TEXT: 'If no one reacts within this period, the alert is transmitted to an operator.'
      },
      EXPLANATION: 'The operator takes charge of the call and responds to the needs of the person carrying the tracker. Depending on the situation, they can contact relatives or call for help.',
      PRICE: 'This option costs € 9.99 per month and can be deactivated at any time.',
      SOS: {
        COMMON_TEXT: 'Your loved one presses the SOS button on their tracker.'
      },
      TIME: {
        COMMON_TEXT: 'You are notified and have 30 seconds to react to the alert.'
      },
      TITLE: 'Learn about our new option: remote assistance ',
      USE_CASE: 'This option allows the person carrying the tracker to be contacted by a specialised tele-assistance platform, available 24/7.'
    },
    SIDE_PAGES: {
      COMMON_TEXT: {
        PET: 'In the vertical tab on the left, you can find all the management and use pages for your tracker. The History tab allows you to view your animal\'s movements and the Activity tracking tab to find out its energy expenditure. The Zones tab allows you to configure zones, the Settings tab contains your pet\'s profile and the Subscription tab allows you to easily manage your subscription and your options.',
        SILVER: 'In the vertical tab on the left, you can find all the management and use pages for your tracker. The History tab allows you to check the movements of your loved one and the Zones tab allows you to configure geofences.\n The Settings tab allows you to configure the number to be called in the event of an SOS, as well as the messages associated with each of the tracker\'s lateral buttons. Finally, the Subscription tab allows you to very easily manage your subscription and your options.'
      },
      TITLE: 'Other pages'
    },
    SKIP: 'Skip the tutorial',
    SUPERLIVE: {
      COMMON_TEXT: 'This button allows you to trigger the "superlive" mode: a new position every 10 seconds for 5 minutes.',
      TITLE: 'The "superlive" button'
    },
    TUTORIAL_START: {
      BUTTON: 'Continue the tutorial',
      COMMON_TEXT: 'Great, your tracker is now ready to use. Let\'s continue with a quick overview of your My Weenect account area.'
    },
    WAITING_GPS_POSITION: 'Finding a GPS position',
    WAITING_GPS_POSITION_HINT: 'Turn your tracker on outdoors'
  },
  optionCardExpired: {
    PROPOSAL: 'Please update your bank card to continue using our services.',
    UPDATE_CARD: 'Update your card details now',
    WARNING: '<1>Warning!</1> You cannot subscribe to this option because <1>your bank card has expired</1>.'
  },
  optioncancellation: {
    OFFER_ACCEPT_BUTTON: 'Enjoy a free month',
    OFFER_CONFIRMATION_BUTTON: 'Return to the app',
    OFFER_CONFIRMATION_TEXT: 'Your option remains active and your next payment will be on {date}.',
    OFFER_CONFIRMATION_TITLE: 'Option updated!',
    OFFER_PREMIUM_TEXT: 'Stay one more month and enjoy your Premium Pack at no cost!',
    OFFER_REFUSE_BUTTON: 'Deactivate anyway',
    OFFER_SERENITY_TEXT: 'Stay one more month and enjoy your Serenity Pack at no cost!',
    OFFER_TITLE: 'What if we offered you 1 month free?',
    PREMIUM_BUTTON: 'Deactivate Premium Pack',
    PREMIUM_HEADER: 'Premium Pack',
    PREMIUM_QUESTION: 'Why do you want to deactivate the Premium Pack?',
    PREMIUM_TITLE: 'Deactivate Premium Pack',
    REASON_NOT_MATCHING_NEED: 'The warranty does not meet my needs',
    REASON_NO_NEED_FEATURES: 'I do not need these features',
    REASON_NO_USE: 'I no longer use the tracker',
    REASON_OTHER: 'Other',
    REASON_OTHER_PLACEHOLDER: 'Tell us more...',
    REASON_SUBSCRIBED_BY_MISTAKE: 'I subscribed by mistake',
    REASON_TOO_EXPENSIVE: 'The option is too expensive',
    SERENITY_BUTTON: 'Deactivate Serenity Pack',
    SERENITY_HEADER: 'Serenity Pack',
    SERENITY_QUESTION: 'Why do you want to deactivate the Serenity Pack?',
    SERENITY_TITLE: 'Deactivate Serenity Pack'
  },
  payment: {
    ADD_NEW_PAYMENT_REGULARISE: 'Please register a new payment method or correct your situation.',
    EXPIRACY_CREDIT_CARD_TEXT: 'Please add a new payment method to regularize your situation.',
    NO_PAYMENT_MEAN_YET: 'No payment method for the moment',
    NO_PAYMENT_YET: 'No payment for the moment',
    UPDATE_PAYMENT_REGULARISE: 'If you want to continue using your tracker, please update or change your payment method now.',
    WARNING_ERROR: 'There seems to be a problem with your payment method.',
    WARNING_EXPIRACY_CREDIT_CARD: 'Warning, your credit card has expired.',
    WARNING_NOT_ENOUGH_FOUNDS: 'Warning, it seems that there are not enough funds in your account.'
  },
  payments: {
    CARD: {
      ACCEPTED: '(CB, VISA, Mastercard, American Express)',
      DESCRIPTION: '30 days satisfaction or refund',
      NAME: 'Credit card'
    },
    STATUS: {
      CANCELED: 'Cancelled',
      ERROR: 'Failure',
      NEW: 'Being processed',
      PAYMENT_ERROR: 'Payment failure',
      PAYMENT_ERROR_EXPLAIN_TEXT: 'An error occurred with your payment. Please try again in a few minutes or contact',
      PAYMENT_RETRY: 'Try again',
      PAYMENT_SAV: 'customer service.',
      PAYMENT_SUCCESS: 'Payment successful!',
      PAYMENT_SUCCESS_TEXT: 'Your payment has been processed. You can now begin your Weenect experience!',
      PAYMENT_SUCCESS_TEXT_APP: 'Your payment has been processed.',
      PENDING: 'Being processed',
      REFUNDED: 'Refunded',
      SUCCESS: 'Confirmed'
    },
    TRANSFER: {
      DESCRIPTION: '15 extra days to change your mind, 30 days satisfaction or refund',
      NAME: 'Direct debit'
    }
  },
  periods: {
    ALT: {
      MONTH: '1 month',
      YEAR: '1 year',
      YEAR_plural: '{{count}} years'
    },
    BASE: {
      MONTH: 'month',
      YEAR: 'year'
    }
  },
  popinpremium: {
    BADGE_PREMIUM: 'PREMIUM',
    CARDSBLOCK_3D_DESCRIPTION: 'An immersive 3D view in your history to relive every trip as if you were there.',
    CARDSBLOCK_3D_TITLE: '3D Replay',
    CARDSBLOCK_ACTIVEPLUS_DESCRIPTION: 'Ultra-frequent positioning to never miss their movements.',
    CARDSBLOCK_ACTIVEPLUS_TITLE: 'Active Plus Mode',
    CARDSBLOCK_ALERTS_DESCRIPTION: 'Receive your alerts by SMS.',
    CARDSBLOCK_ALERTS_TITLE: 'SMS Alerts',
    CARDSBLOCK_CONTACTS_DESCRIPTION: 'Share tracking with up to 10 close contacts.',
    CARDSBLOCK_CONTACTS_TITLE: '10 Trusted Contacts',
    CARDSBLOCK_HEATMAP_DESCRIPTION: 'View their favorite areas and frequent routes.',
    CARDSBLOCK_HEATMAP_TITLE: 'Movement Heatmap',
    CARDSBLOCK_MAPS_DESCRIPTION: 'Easily locate them, even in complex terrain: satellite view, reliefs, and trails.',
    CARDSBLOCK_MAPS_TITLE: 'Satellite & 3D maps',
    CARDSBLOCK_SHARE_DESCRIPTION: 'Invite your close contacts securely, without giving your password.',
    CARDSBLOCK_SHARE_TITLE: 'Share Account Access',
    CARDSBLOCK_SUPERLIVE_DESCRIPTION: 'Locate your pet every second, longer.\nStandard feature: up to 2 min',
    CARDSBLOCK_SUPERLIVE_TITLE: 'Superlive up to 30 min',
    CARDSBLOCK_TITLE: 'What you unlock',
    CTA: 'Try 1 month free',
    DESCRIPTION: 'Enjoy all Premium features free for 1 month. \nNo commitment, cancel with 1 click.',
    REASSURANCEBLOCK_1MONTHFREE: '1 month free',
    REASSURANCEBLOCK_BADGE: 'NO COMMITMENT',
    REASSURANCEBLOCK_CANCELABLE: 'Cancelable with 1 click',
    REASSURANCEBLOCK_FREETODAY: '{{value}} today',
    REASSURANCEBLOCK_PERMONTH: 'then {{value}}/month',
    REASSURANCEBLOCK_REMINDER: 'Reminder before the end',
    SUBTITLE_CTA: 'Then {{value}} /month · no commitment · offer not valid if you have already used it',
    TITLE: 'Unlock the premium GPS experience'
  },
  popinserenity: {
    ASSISTANCEBLOCK_FOOTER: 'Human support at every step',
    ASSISTANCEBLOCK_GUIDE: 'Search guide by country',
    ASSISTANCEBLOCK_INTRO: 'And if your pet disappears, we act alongside you:',
    ASSISTANCEBLOCK_ONLINEAD: 'Online announcement posting',
    ASSISTANCEBLOCK_OVERLINE: 'PRIORITY SUPPORT',
    ASSISTANCEBLOCK_PHONEFOLLOWUP: 'Phone follow-up by our advisors',
    ASSISTANCEBLOCK_POSTER: 'Custom printable poster',
    ASSISTANCEBLOCK_PRIORITYSUPPORT: 'Priority customer service support in case of emergency',
    ASSISTANCEBLOCK_TITLE: 'A team to help find it',
    BADGE_NOCOMMITMENT: 'NO COMMITMENT',
    BADGE_SERENITY: 'SERENITY PACK',
    CTA: 'Activate the Serenity Pack',
    DESCRIPTION: 'Complete protection for your tracker and a team actively supporting you if your pet gets lost.',
    PRICE_PERMONTH: '{{price}} /month',
    PRICE_PREFIX: 'For',
    PROTECTIONBLOCK_BREAKAGE: 'Accidental damage',
    PROTECTIONBLOCK_DESCRIPTION: 'Loss, theft, or damage: we send you a new tracker.',
    PROTECTIONBLOCK_FOOTER: 'Up to 3 replacements · {{shipping_price}} shipping',
    PROTECTIONBLOCK_LOSS: 'Tracker loss',
    PROTECTIONBLOCK_OVERLINE: 'PROTECTION',
    PROTECTIONBLOCK_THEFT: 'Tracker theft',
    PROTECTIONBLOCK_TITLE: 'Your tracker replaced within 24 hours',
    REASSURANCEBLOCK_CANCELABLE: 'Activate or cancel with 1 click',
    REASSURANCEBLOCK_NOCOMMITMENT: 'No commitment',
    TITLE: 'Keep peace of mind, no matter what happens.'
  },
  popup: {
    premium_pack_popup_flash_description_1_web: 'Steady light, in addition to the already included blinking.',
    premium_pack_popup_flash_description_2_web: 'And lighting for up to 30 minutes without interruption.',
    premium_pack_popup_flash_title_web: 'Another style of flashlight, for even more safety (*only on Tracker XS and XT)',
    premium_pack_popup_map_description_1_web: 'HD Satellite view, reliefs, forest paths, and hiking trails.',
    premium_pack_popup_map_title_web: 'Additional maps to adapt to all terrains',
    premium_pack_popup_notifications_description_1_web: 'Add up to 10 contacts',
    premium_pack_popup_notifications_description_2_web: '40 SMS credits per month.',
    premium_pack_popup_notifications_description_3_web: 'In addition to push and email notifications, already included.',
    premium_pack_popup_notifications_title_web: 'All alerts on your phone, even without internet connection',
    premium_pack_popup_ring_vibrate_description_1_web: 'Instead of 10 seconds without the Premium Pack.',
    premium_pack_popup_ring_vibrate_title_web: 'Ringing and Buzzer for up to 30 seconds',
    premium_pack_popup_superlive_description_1_web: 'Instead of 2 minutes without the Premium Pack.',
    premium_pack_popup_superlive_title_simplified_web: 'Superlive for up to 30 minutes without interruption'
  },
  powersavingarea: {
    ACTIVE_STATE: 'Active',
    AIRPLANE_MODE: 'Airplane mode',
    AIRPLANE_MODE_STATE_DISABLED: 'Disabled',
    AIRPLANE_MODE_STATE_ENABLED: 'Enabled',
    INACTIVE_STATE: 'Inactive',
    REDIRECT_APPLICATION: 'The modification, creation of zones, and activation of airplane mode are done directly from the Weenect mobile app.'
  },
  premium_pack_popup_flash_description_1: 'Steady light, in addition to the already included blinking.',
  premium_pack_popup_flash_description_2: 'And lighting for up to 30 minutes without interruption.',
  premium_pack_popup_flash_title: 'Another style of flashlight, for even more safety (*only on Tracker XS and XT)',
  premium_pack_popup_map_description_1: 'HD Satellite view, reliefs, forest paths, and hiking trails.',
  premium_pack_popup_map_title: 'Additional maps to adapt to all terrains',
  premium_pack_popup_notifications_description_1: 'Add up to 10 contacts',
  premium_pack_popup_notifications_description_2: '40 SMS credits per month.',
  premium_pack_popup_notifications_description_3: 'In addition to push and email notifications, already included.',
  premium_pack_popup_notifications_title: 'All alerts on your phone, even without internet connection',
  premium_pack_popup_ring_vibrate_description_1: 'Instead of 10 seconds without the Premium Pack.',
  premium_pack_popup_ring_vibrate_title: 'Ringing and Buzzer for up to 30 seconds',
  premium_pack_popup_superlive_description_1: 'Instead of 2 minutes without the Premium Pack.',
  premium_pack_popup_superlive_title_simplified: 'Superlive for up to 30 minutes without interruption',
  premium_pack_popup_title: '<strong>Access</strong> the Premium Pack for <strong>free</strong>',
  register: {
    EMAIL_PLACEHOLDER: 'Email address',
    ERROR_EMAIL_ALREADY_USED: 'This email address is already linked to an account',
    FAILED_DESCRIPTION: 'Please log in again using your credentials.',
    FAILED_TITLE: 'Your account has been created!',
    FIRSTNAME_PLACEHOLDER: 'First name',
    LASTNAME_PLACEHOLDER: 'Last name',
    LOGIN_CTA: 'Login',
    LOGIN_PROMPT_TITLE: 'Already a customer?',
    PASSWORD_CONFIRM_PLACEHOLDER: 'Password confirmation',
    PASSWORD_PLACEHOLDER: 'Password',
    PHONE_PLACEHOLDER: 'Phone number',
    SUBMIT_CTA: 'Create my account',
    TITLE: 'Create an account'
  },
  registerSummaryTable: {
    BILLED_MONTH: 'The payment is monthly',
    BILLED_NOW: 'Immediate invoicing',
    BILLED_THREE_YEARS: 'The payment is made once every three years',
    BILLED_TWO_YEARS: 'Billed once every two years',
    BILLED_YEAR: 'The payment is made once a year',
    HINT_OPTIONS_PRICE: 'The options, for the amount of {{amount}}, will be billed separately from the subscription and within two hours.',
    OPTION_UPGRADE: 'Add the {{name}} option for only {{price}}/{{period}}',
    PAY_HINT: 'Click the "Pay and Activate" button and pay {{subscriptionPrice}} for the subscription.',
    SUBSCRIPTION_UPGRADE: 'Change to a 2 year subscription and save {{amount}} each year.',
    TOTAL: 'Total price'
  },
  registerTracker: {
    BUY_LINK: 'Don\'t have a Weenect tracker yet? <1> You can buy them here </1>',
    ERRORS: {
      UNKNOWN: 'There was a problem activating your tracker, please try again'
    },
    HEADLINE: 'Activate a new tracker',
    IMEI_INPUT: {
      LABEL: 'IMEI number',
      PLACEHOLDER: 'You will find the IMEI number on the back of your tracker.'
    },
    NAME_INPUT: {
      LABEL: 'Tracker name',
      PLACEHOLDER: 'Name of who is carrying the tracker'
    }
  },
  remoteAssistance: {
    BASE: 'Remote assistance',
    FEATURES: 'If the SOS button is pressed and you do not respond within 30 seconds, the SOS alert and voice call are automatically transmitted to our call centre, 24 hours a day, 7 days a week. Our agents are empowered to contact emergency services such as the police or the ambulance service.',
    FORM: {
      ADDRESS_INPUT: {
        LABEL: 'Address',
        PLACEHOLDER: 'Number and name of street'
      },
      BACK: 'Cancel',
      CITY_INPUT: {
        LABEL: 'Town/City',
        PLACEHOLDER: ''
      },
      EXTRA_PHONE: {
        LABEL: 'Secondary phone (optional)',
        PLACEHOLDER: ''
      },
      HEADLINE: 'Registration for remote assistance',
      NAME_INPUT: {
        LABEL: 'Full name',
        PLACEHOLDER: 'First name LAST NAME'
      },
      PHONE: {
        LABEL: 'Telephone',
        PLACEHOLDER: ''
      },
      POSTAL_CODE_INPUT: {
        LABEL: 'ZIP code',
        PLACEHOLDER: ''
      },
      SAVE: 'Confirm',
      TERMS: 'I have read and accept the <1> terms of use </1> of the service',
      TEXT: 'Enter the details of your loved one (the holder of the tracker). This will allow our agents to help them in the event of an SOS alert.'
    },
    PENDING: {
      WAITING_FOR_CALL_TEST: 'Registration form validated. Waiting for the test call. \nYou must now make a test call in order to finalise the activation of the option. Refer to the email sent to you on how to do this.',
      WAITING_FOR_RESIGN: 'Option is being deactivated. \nYour request to deactivate the option has been received. Our agents are currently taking care of the administrative formalities. The deactivation will be effective shortly.',
      WAITING_FOR_VALIDATION: 'Registration form being validated. \nThe information you provided when you subscribed to the option is currently being verified by our agents. As soon as this information is validated, we can proceed with the last step of the option\'s activation: a test call must be made to verify that everything is working properly.'
    },
    USER_PHONE: {
      TEXT: 'Enter your details. This will allow our agents to contact you in the event of an SOS alert.'
    }
  },
  replacetracker: {
    ERROR_ALREADY_LINKED: 'This tracker is already linked to an account',
    ERROR_INVALID: 'Invalid IMEI number',
    ERROR_TYPE_MISMATCH: 'You cannot replace a pet tracker with a person tracker, or vice versa.',
    IMEI_PLACEHOLDER: 'IMEI number',
    NEW_IMEI_LABEL: 'Enter the IMEI of the new tracker:',
    POPIN_ADD_CTA: 'Add a tracker',
    POPIN_ADD_DESCRIPTION: 'To track an additional pet or loved one. A new tracker requires its own subscription, and your current trackers remain active.',
    POPIN_ADD_TITLE: 'Add a tracker:',
    POPIN_REPLACE_CTA: 'Replace a tracker',
    POPIN_REPLACE_DESCRIPTION: 'To change tracker without altering your subscription. Ideal if your tracker is lost or broken, or to upgrade to a newer model. The old tracker is deactivated.',
    POPIN_REPLACE_TITLE: 'Replace a tracker:',
    POPIN_TITLE: 'Add or replace a tracker',
    SELECT_TRACKER_LABEL: 'Select the tracker to replace:',
    SUBMIT_CTA: 'Replace',
    SUBTITLE: 'The current subscription and settings will be transferred to the new tracker after replacement. The GPS location history of the previous tracker will be lost.',
    TITLE: 'Replace a tracker',
    TRACKER_IMEI: 'IMEI: {{imei}}'
  },
  safetyarea: {
    REDIRECT_APPLICATION: 'Editing and creating areas can only be done directly from the Weenect mobile app.'
  },
  santevet: {
    ADVANTAGE: {
      FIRST: '<span>6 months of Weenect subscription offered</span> at subscription',
      PROMO_CODE: 'with the code',
      SECOND: '<span>20€ of prevention offered/year</span> in addition to the already included package'
    },
    FOOTER: {
      BUTTON: 'See prices',
      TEXT: 'By continuing, you agree to be contacted by Santévet.'
    },
    OFFERS: {
      BILL: {
        TEXT: 'From <span>60% to 100%</span> and up to 2,500€/year.',
        TITLE: 'Your costs reimbursed in case of illnesses and accidents'
      },
      CROSS: {
        TEXT: 'Benefit <span>free of charge</span> and <span>at any time</span> from a telephone assistance.',
        TITLE: 'A 24/7 emergency veterinary service'
      },
      MONEY_PUSH: {
        TEXT: 'SantéVet advances your costs <span>free of charge</span> at the end of the consultation.',
        TITLE: 'The advance payment of your veterinary expenses with Payvet'
      },
      SERINGE: {
        TEXT: '<span>Up to 150€/year</span> for preventive care (vaccinations, antiparasitics, etc).',
        TITLE: 'A prevention package included in all offers'
      },
      TITLE: 'The advantages of Santévet:'
    },
    SUBTITLE: 'and enjoy exclusive benefits',
    TITLE: 'Insure {{name}} for only {{amount}} €/month',
    TITLE_WITHOUT_PRICE: 'Insure {{name}} right now'
  },
  share_account_link_expired_popin_text: 'The login link you are using has expired. Please generate a new one to log in.',
  share_account_link_expired_popin_title: 'Link expired',
  signup: {
    ALREADY_MEMBER_TEXT: 'Already a user?',
    CREATE_ACCOUNT_HEADLINE: 'Create an account',
    LOGIN_TEXT: 'Log in',
    MARKETING_AGREEMENT_TEXT: 'I agree to receive special offers and promotions from Weenect\'s partners',
    RETRY: 'Try again',
    SIGNUP_ERRORS: {
      EMAIL_ALREADY_EXISTS: 'This email address is already used by an account',
      POPIN_EMAIL_ALREADY_EXIST: '<1>Oops</1>, it looks like this email address has already been used.',
      UNKNOWN: 'Login failure, please try again'
    },
    SIGN_IN_TEXT: 'Login',
    SUBMIT_BUTTON: 'Create my account',
    TERMS_AGREEMENT_TEXT: 'I accept <1> the terms of use </1> of the service'
  },
  simInfo: {
    TITLE: 'SIM number'
  },
  subOptions: {
    CANCEL: {
      EXPIRATION_DATE: 'This option will still be active until {{date}}',
      HEADLINE: 'Would you like to cancel the {{option}} option?'
    },
    MAP: {
      BASE: 'Multimap Pack',
      FEATURES: 'Get the advantage of more comprehensive and regularly updated maps that allow you to better see and monitor your tracker\'s movements. (HD Satellite, Terrain Map, Forest Trails)',
      TITLE: 'Premium maps:'
    },
    PREMIUM: {
      BASE: 'Premium Pack',
      BUTTON: {
        FREEMONTH: 'Try it for free for 1 month!'
      },
      DEACTIVATE: 'By deactivating this option you will lose your premium benefits.',
      FEATURE: {
        CHAT: {
          BASE: 'Online chat',
          TEXT: 'Chat live with a Weenect advisor in your app. Service available 7 days a week, from 9 am to 6 pm.'
        },
        SMS: {
          TEXT: 'Get text notifications (40 text messages per month), on top of the push and email notifications already included in the subscription.'
        }
      },
      FEATURE_TEXT: 'Enjoy exclusive benefits (SMS alerts, HD maps) within the application.',
      FREEMONTH: {
        BASE: 'First month free!',
        BASE2: 'FREE'
      },
      SUBTITLE: 'The Premium Pack includes the following features:',
      SUB_LEGAL: 'This membership will automatically renew each month, using the payment method you entered when signing up. You can cancel the membership at any time in your personal settings.',
      TEXT_INFO_PRICE: 'Then {{price}}/month after the first month.',
      TITLE_DISCOVER: 'Discover the exclusive benefits: ',
      TITLE_POPUP: 'Become a Premium member!'
    },
    SMS_PACK: {
      ALT_FEATURES: {
        one: 'Receive all alerts by SMS',
        other: ''
      },
      BASE: 'SMS pack',
      FEATURES: {
        one: 'Receive all your alerts by text message (up to 20 texts per month). Please note that without this option, you will still receive the alerts via push messages (app) and email.',
        other: ''
      }
    },
    UNDEFINED: {
      PAYMENTS: 'Payment for the option'
    },
    WARRANTY: {
      ALT_FEATURES: {
        one: 'Get a new tracker for free if your existing one is broken, lost or stolen.',
        other: 'Pay by debit card with cancellation possible at any time',
        two: 'Your tracer replaced in 48H in case of loss, breakage or theft, without conditions.'
      },
      BASE: 'Multi-risk warranty',
      EXPLAINER: 'The standard warranty only covers the tracker against manufacturing problems.',
      FEATURES: 'Get a free replacement tracker if your current tracker gets broken, lost or stolen: no claim justification required. The standard warranty covers the tracker against manufacturing defects only.'
    }
  },
  subscription: {
    ADD_A_PROMO_CODE: 'Add a promotional code',
    CANCEL_PAGE: {
      BUTTON: 'Retry',
      TEXT: 'Your payment has been cancelled',
      TITLE: 'Payment cancelled'
    },
    COMMON_TEXT: {
      MONTH: 'per month',
      OR: 'i.e.'
    },
    FAIL_PAGE: {
      BUTTON: 'Try again',
      TEXT: 'Your payment was unsuccessful. We invite you to try again.',
      TITLE: 'Payment failed'
    },
    FEATURES: {
      APP_ACCESS: 'Unlimited access to the application and location service',
      REFOUND: '15 day trial: satisfied or your money back',
      SAV: 'Customer service available 6 days a week. \nGuaranteed response within 24 hours.',
      WARRANTY: '24 month manufacturer\'s warranty'
    },
    FIRST_PAGE: {
      BANNER_NEW_PRICES_DESCRIPTION: 'The rates shown below apply until the end of your commitment period. At the next renewals after July 1, 2026, the new rate will be applied.',
      BANNER_NEW_PRICES_TITLE: 'New rates from July 1, 2026',
      BUTTON: 'Next',
      BY_YEAR: 'That’s {{price}} per year',
      DETERRENT_MONTHLY_POPIN: {
        BUTTON: {
          CHANGE: 'Change plan',
          CONTINUE: 'Continue anyway'
        },
        DESCRIPTION: 'This plan has no withdrawal period and does not include the lifetime guarantee on your tracker.\nChoose the 1-year subscription instead!',
        TITLE: 'Are you sure you want to take the monthly subscription?'
      },
      FOR_YEAR: 'That’s {{price}} for {{period}} years',
      MODAL_GIFT_CARD: {
        BUTTON: 'Apply',
        DELETE_BUTTON: 'Remove',
        ERROR: 'The entered gift card number is invalid',
        INPUT_LABEL: 'Gift card',
        TITLE: 'Add a gift card'
      },
      MODAL_INFORMATION: {
        TEXT: 'The SIM card directly integrated into your tracker requires a subscription (to cover the service fees).',
        TITLE: 'Why choose a subscription?'
      },
      SUBSCRIPTION_CGV: {
        FIRST_TEXT: 'All subscriptions are paid in one go and automatically renewed according to the chosen period. You can cancel this renewal at any time before the end of the current period.',
        INCLUDES: {
          FIRST: 'satisfaction guaranteed or your money back',
          FIRST_BOLD: '15 or 30 days minimum trial period depending on the subscription:',
          FOURTH: 'manufacturer 24 months minimum',
          FOURTH_BOLD: 'Warranty',
          SECOND: 'and to the unlimited location service.',
          SECOND_BOLD: 'Access to the app',
          THIRD: 'available 6/7 days. Response guaranteed within 24 hours.',
          THIRD_BOLD: 'Customer service'
        },
        SECOND_TEXT: 'To benefit from the subscriptions, you must enter valid banking information and accept the',
        SECOND_TEXT_LINK: 'terms and conditions of service.',
        TITLE: 'All subscriptions include:'
      },
      SUBSCRIPTION_CHOICE: {
        CHIP_BEST_OFFER: 'Best offer',
        CHIP_ECO_OFFER: 'Budget Offer',
        CHIP_ONE_MONTH: 'Flexible offer',
        CHIP_ONE_YEAR: 'Popular offer',
        CHIP_POPULAR_OFFER: 'Popular offer',
        CHIP_THREE_YEAR: 'Save {{count}}%',
        SEE_MORE: 'See more subscriptions',
        SUBSCRIPTION_TITLE_GIFT_CARD: 'I have a gift card',
        SUBSCRIPTION_TITLE_MONTHLY: 'Monthly subscription',
        SUBSCRIPTION_TITLE_one: 'Subscription for {{count}} year',
        SUBSCRIPTION_TITLE_other: 'Subscription for {{count}} years',
        TIP_30_DAYS_WARRANTY: '🛡️ Satisfaction guaranteed or your money back: you have 30 days to change your mind.',
        TIP_ONE_MONTH: '⚠️ Save {{price}} by choosing the 1-year subscription.',
        TIP_ONE_MONTH_ALT: '⚠️ The monthly subscription would cost you {{loss}} over one year.',
        TIP_ONE_YEAR: '💡 Save {{savings}}% by choosing the 3-year plan.',
        TIP_THREE_YEAR: '🛡️ Extended "satisfied or refunded" guarantee: you have 30 days to change your mind.',
        TIP_TWO_YEAR: '💡 Get one extra year of subscription for only {{additional_cost}} more by choosing the 3-year plan.',
        TITLE: 'Choose your subscription'
      },
      SUBTITLE: 'Subscriptions come with a “satisfied or refunded” guarantee: you have 15 days to change your mind.'
    },
    FOR_MINUS_X_PERCENT: '{{percent}}% off',
    FREE: 'FREE',
    HEADER: {
      STEP: 'Step',
      TITLE: {
        FIRST_PAGE: 'Subscription',
        SECOND_PAGE: 'Options',
        THIRD_PAGE: 'Payment'
      }
    },
    HOME_PAGE: {
      TITLE: ''
    },
    INFO_CGU: 'To benefit from the subscriptions, you must enter valid banking information and accept the general',
    INFO_CGU_BUTTON: 'the general conditions of use of the service.',
    INFO_OPTION: 'Payment is monthly, cancellation is possible at any time.',
    MANAGE: {
      SERENITY_PACK: {
        DESCRIPTION1: 'Priority support and replacement of your tracker in case of loss, damage, or theft — no proof required.',
        DESCRIPTION2: 'If your pet goes missing despite their tracker, our team will support you by creating outreach tools to help you find them.',
        TITLE: 'Serenity Pack'
      }
    },
    MANAGE_MEAN: {
      MEAN: {
        CARD: 'Credit card',
        DIRECT_DEBIT: 'Direct debit',
        EDIT: 'Edit',
        EXPIRED: '⚠️ This payment method has expired.\nClick to reconfigure it or add a new payment method.',
        EXPIRY_DATE: 'Expiration date',
        INVALID: '⚠️ This payment method has been disabled due to multiple payment failures.\nSelect it to reconfigure or add a new payment method.',
        NO_MEAN: {
          BUTTON: 'Add a payment method',
          TITLE: 'You don’t have a saved payment method.'
        },
        NO_REFERENCE: 'Change payment method',
        SUBTITLE: 'The payment method registered below will be used to renew your subscriptions and options.\nClick on it to modify.',
        TITLE: 'Manage your payment method'
      },
      TITLE: 'Payment method and invoices'
    },
    MANAGE_PAGE: {
      ACCOUNT_OPTIONS: {
        DESCRIPTION: 'The account options apply to all trackers on your account.',
        PREMIUM_PACK: {
          DESCRIPTION: '- Superlive up to 30 min\n- Additional maps for all terrains\n- Movement heatmap\n- SMS alerts\n- 10 trusted contacts\n- Share access to your account\n- Active Plus mode\n- 3D replay',
          TITLE: 'Premium Pack'
        },
        TITLE: 'Account Options',
        WARRANTY: {
          DESCRIPTION: '💡 Priority support and replacement of your tracker in case of loss, damage, or theft — no proof required.\nIf your pet goes missing despite their tracker, our team will support you by creating outreach tools to help you find them.',
          TITLE: 'Serenity Pack'
        }
      },
      ACTIVATE: {
        BUTTON: 'Activate'
      },
      ADD_SUBSCRIPTION_BUTTON: 'Choose a subscription',
      CANCEL: {
        BUTTON: 'Cancel'
      },
      CANCEL_CONFIRM: {
        GENERIC: {
          BUTTON: {
            CONTINUE_CANCELLATION: 'Continue',
            KEEP_ADVANTAGES: 'Keep my benefits'
          },
          TITLE: 'Are you sure?'
        },
        OPTION: {
          PREMIUM_PACK: {
            SUBTITLE: 'By disabling the renewal of the Premium Pack, you will lose the following benefits starting from {{date}}:'
          },
          WARRANTY: {
            SUBTITLE: 'By disabling the renewal of your Serenity Pack, you will lose the following benefits from {{date}}:'
          }
        },
        SUBSCRIPTION: {
          ADVANTAGES: {
            DESCRIPTION: '- Access to Weenect services for this tracker\n- Lifetime manufacturer warranty for your tracker'
          },
          SUBTITLE: 'By disabling the renewal of your subscription, you will lose the following benefits starting from {{date}}:'
        }
      },
      EDIT: {
        BUTTON: 'Edit',
        CANCEL_REVIEW: {
          DETAILS: {
            SUBTITLE: 'We would like to better understand what did not work for you. Your feedback is valuable and helps us improve our service.'
          },
          OPTION: {
            SUBTITLE: {
              PREMIUM_PACK: 'We’re sorry to see you go.\nWhat is the reason you want to cancel the renewal of your Premium Pack?',
              WARRANTY: 'We’re sorry to see you go.\nWhy would you like to cancel the renewal of your Serenity Pack?'
            },
            TITLE: 'Disable option renewal'
          },
          REASON: {
            AFTER_SALES_SERVICE: 'Bad experience with customer service',
            BAD_NETWORK: 'The network connection is poor',
            BAD_PRECISION: 'Poor GPS locations',
            BATTERY: 'Insufficient battery life',
            LOST_BROKEN: 'I lost / broke my tracker',
            MISSING_FEATURES: 'One or more features are missing',
            MOBILE_APPLICATION: 'The app does not work',
            NOT_ENOUGH_FEATURES_PREMIUM: 'Not enough features (Premium Pack)',
            NOT_SATISFIED: 'I am not satisfied',
            NO_USE: 'I no longer use the tracker',
            OTHER: 'Other',
            PLACEHOLDER: 'Tell us more…',
            TOO_EXPENSIVE: 'Subscription too expensive',
            TOO_EXPENSIVE_OPTION: 'The option is too expensive',
            TRACKER_FORMAT: 'Tracker too big / heavy',
            TRACKER_ISSUE: 'Issues with the tracker',
            WILL_REACTIVATE_LATER: 'To suspend automatic renewal (I want to continue using the tracker)'
          },
          SUBSCRIPTION: {
            SUBTITLE: 'We’re sorry to see you go.\nWhat is the reason you want to cancel the renewal of your subscription?',
            TITLE: 'Disable subscription renewal'
          }
        },
        ERROR: {
          HEADER: 'Error',
          SUBTITLE: 'The modification of your subscription failed. Please try again.\nIf the problem persists, contact our customer support.',
          TITLE: 'Oops, something went wrong.'
        }
      },
      EDIT_OPTION: {
        HEADER: 'Change option'
      },
      EDIT_RESULT: {
        BUTTON: 'Back to menu',
        CANCELLATION_SUCCESS: {
          OPTION: {
            SUBTITLE: 'The automatic renewal of your option {{option_title}} has been successfully canceled.'
          },
          SUBSCRIPTION: {
            SUBTITLE: 'The automatic renewal of your subscription has been successfully canceled.'
          },
          TITLE: 'Automatic renewal canceled'
        },
        CHANGE_SUBSCRIPTION: {
          SUCCESS: {
            SUBTITLE: 'Your subscription will be renewed on <strong>{{next_charge_at}}</strong> at the rate of <strong>{{upgrade_amount}}</strong> for the <strong>{{update_offer_title}}</strong> plan.',
            TITLE: 'Subscription change successful!'
          }
        },
        OFFER_SUCCESS: {
          CREATE_TICKET: {
            SUBTITLE: 'Your priority support request has been saved.\nOne of our advisors will contact you very soon to resolve your issue.',
            TITLE: 'Request recorded'
          },
          FREE_MONTHS: {
            SUBTITLE: 'We are delighted to continue protecting {{tracker_name}}.\nYour next renewal will be on <strong>{{next_charge_at_with_free_months}}</strong>.',
            TITLE: 'Subscription updated!'
          },
          UPGRADE: {
            SUBTITLE: 'We are delighted to continue protecting {{tracker_name}}.\nYour subscription will renew on <strong>{{next_charge_at}}</strong> at the rate of <strong>{{upgrade_amount}}</strong> for the <strong>{{update_offer_title}}</strong> plan.',
            TITLE: 'Subscription updated!'
          }
        }
      },
      EDIT_SUBSCRIPTION: {
        CANCEL: {
          SUBTITLE: 'Your subscription will no longer be automatically renewed.\nYou will lose access to your services on {{date}}.',
          TILE: 'Disable renewal',
          TITLE: 'Disable renewal?'
        },
        CHANGE: {
          SUBTITLE: 'The subscription change will be applied at the end of the current period.',
          SUCCESS: {
            BUTTON: 'Back to menu',
            SUBTITLE: 'Your subscription will be renewed with the following plan:\n<strong>{{new_offer_title}}</strong>\nBilling and renewal for this plan will occur on <strong>{{date}}</strong>.',
            SUBTITLE_1: 'Your subscription will be renewed with the following plan:',
            SUBTITLE_2: 'Billing and renewal with this plan will take place on {{date}}.',
            TITLE: 'Subscription change recorded!'
          },
          TITLE: 'Change subscription?'
        },
        ERROR: {
          SUBTITLE: 'The action was not processed.\nPlease try again later.',
          TITLE: 'Error'
        },
        HEADER: 'Edit subscription',
        OVERCHARGE_PER_YEAR: 'you lose {{price}} / year',
        SAVINGS_PER_YEAR: 'you save {{price}} / year'
      },
      FIRST_MONTH_FREE: '1st month free',
      INVALID_PAYMENT_MEAN_POPIN: {
        BUTTON: 'Update my payment method',
        SUBTITLE: {
          ERRORS: 'Your payment method is invalid.\nClick the button below to update it.',
          EXPIRED: 'Your payment method has expired.\nClick the button below to update it.',
          MISSING: 'No payment method is registered on your account.\nClick the button below to add one.'
        },
        TITLE: {
          OPTION: 'Unable to reactivate your option',
          SUBSCRIPTION: 'Unable to reactivate your subscription'
        }
      },
      NO_SUBSCRIPTION: 'This tracker has no subscription.',
      OPTION_STATUS: {
        ACTIVE: {
          DESCRIPTION: 'This option is active and will be automatically renewed on {{date}} for {{period}} at {{price}}.',
          DESCRIPTION_PAST: 'This option is active and will be billed soon for {{period}} at {{price}}.',
          TITLE: 'Automatic renewal active'
        },
        ACTIVE_NO_DATE: {
          DESCRIPTION: 'This option is active.'
        },
        CANCELED: {
          DESCRIPTION: 'The renewal of this option is disabled. Access to the features remains available until {{date}}, but after this date, they will no longer be accessible.',
          TITLE: 'Automatic renewal deactivated'
        },
        EXPIRED: {
          DESCRIPTION: 'This option has expired. Please reactivate it to regain access to the associated features.'
        }
      },
      REACTIVATE: {
        BUTTON: 'Re-activate renewal'
      },
      RETENTION_OFFERS: {
        BUTTON: {
          ACCEPT: 'Accept',
          CONTINUE_CANCELLATION: 'Continue cancellation'
        },
        CREATE_TICKET: {
          BUTTON: 'Request a callback',
          DESCRIPTION: 'Create a priority request and our customer service will contact you first — no waiting, fast and personalized response.',
          TITLE: 'Need help?\nAn advisor will call you back as a priority'
        },
        FREE_MONTHS: {
          DESCRIPTION: 'If our first offer does not meet your expectations, we would like to offer you a second offer just for you: <strong>{{free_months}} months of subscription free!</strong>\n\nYou will therefore continue to protect {{tracker_name}} for free until {{next_charge_at_with_free_months}}.',
          TITLE: '{{free_months}} months free!'
        },
        UPGRADE: {
          BUTTON: 'Save {{savings}} in 1 click',
          DESCRIPTION: 'Because we would be very sad if {{tracker_name}} were no longer protected daily, we offer you an exclusive deal: <strong>{{savings_amount}} savings</strong> on your <strong>{{upgrade_offer_title}}</strong>.\n\nYour subscription will be <strong>{{upgrade_amount}}, or {{upgrade_amount_monthly}}</strong>.\n\nThis offer will apply from {{next_charge_at}}, the renewal date of your current subscription.',
          TITLE: '-{{discount_ratio}}% on your {{upgrade_offer_title}}'
        }
      },
      SUBSCRIBE_AGAIN: {
        BUTTON: 'Subscribe again'
      },
      SUBSCRIPTION_STATUS: {
        ACTIVE: {
          DESCRIPTION: 'Your subscription will be automatically renewed on {{date}} for {{period}} at {{price}}.',
          DESCRIPTION_PAST: 'Your subscription will be billed soon for {{period}} at {{price}}.',
          TITLE: 'Automatic renewal active'
        },
        CANCELED: {
          DESCRIPTION: 'Your subscription is active until {{date}} but will not renew automatically.\nAfter this date, your tracker will stop working.',
          TITLE: 'Automatic renewal deactivated'
        },
        EXPIRED: {
          DESCRIPTION: 'Your subscription has been expired.\nYou need to purchase a new subscription to use this tracker.'
        }
      },
      TITLE: 'Subscription(s) and options',
      TRACKER_SUBSCRIPTIONS_OPTIONS: {
        TITLE: 'Subscription and options of {{name}}'
      }
    },
    MONEY_BACK: 'All subscriptions are invoiced immediately but can be cancelled within 15 days, with a full refund of the amount paid.',
    MONTH: 'Month',
    ONLY: 'only',
    PAYMENTS_LIST: {
      NO_PAYMENTS: {
        TITLE: 'No payment has been made.'
      },
      SUBTITLE: 'View your recent payments below.\nClick on one to download the invoice.',
      TITLE: 'Invoices'
    },
    PAYMENT_INFO: 'Money back guarantee: 15 days to try your tracker',
    PAYMENT_SUBHEADLINE: 'Select a payment method to pay your subscription and activate your tracker.',
    PAYMENT_TITLE: 'Choose your payment method',
    PAYMENT_TITLE2: 'Register your payment method.',
    PENDING_PAGE: {
      BUTTON: 'Cancel',
      TEXT: 'Payment validation is in progress ...',
      TIMEOUT_TEXT: 'Payment validation seems to be taking longer than expected.',
      TITLE: 'Payment in progress'
    },
    PERIOD: {
      MONTH_one: '{{period}} month',
      MONTH_other: '{{period}} months',
      YEAR_one: '{{period}} year',
      YEAR_other: '{{period}} years'
    },
    PREPAYED: '{{price}} paid once',
    PREPAYED_DATE: '{{price}} paid in one instalment on {{date}}',
    PRICE_MONTH_SAVED: 'i.e. {{price}}/month',
    SECONDE_PAGE: {
      BUTTON: 'Proceed to payment'
    },
    SECOND_PAGE: {
      BASKET: {
        TEXT: {
          premium_pack: 'First month free, then',
          warranty: 'The payment is monthly.'
        },
        TOTAL: 'Total including tax'
      },
      OPTION_CHOICE: {
        CHIP: '1st month free',
        TEXT: {
          premium_pack: 'Unlock exclusive features: Superlive up to 30 minutes, additional map views, another flashlight style, or even SMS alerts.',
          warranty: 'Priority support and replacement of your tracker in case of loss, damage, or theft — no proof required.\nIf your pet goes missing despite their tracker, our team will support you by creating outreach tools to help you find them.'
        },
        TITLE: {
          premium_pack: 'Premium Pack',
          warranty: 'Serenity Pack'
        }
      },
      SUBTITLE: 'The options are non-binding and can be canceled at any time from your mobile app or customer area.',
      TITLE: 'Choose your options'
    },
    SUBSCRIPTION_TITLE: {
      MONTH_one: 'Monthly subscription',
      MONTH_other: '',
      YEAR_one: 'Annual subscription',
      YEAR_other: '{{period}}-year subscription'
    },
    SUCCESS_PAGE: {
      BUTTON: 'Return to the app',
      TEXT: 'Click the button below to start using your tracker.',
      TEXT_ASYNC: 'The payment will be collected in a few days.\n\n⚠️ If your bank rejects the payment, the tracker will be deactivated.\n\nClick the button below to start using your tracker.',
      TITLE: 'Payment confirmed'
    },
    SUMMARY: 'Summary',
    THIRD_PAGE: {
      BUTTON: 'Confirm and pay',
      MODAL: {
        ERROR: 'The promotional code is invalid',
        TITLE: 'Promotional code'
      },
      NO_PROVIDER: 'No payment method available',
      PAYMENT_CHOICE: {
        BANK: 'Direct debit',
        CARD: 'Credit card',
        TITLE: 'Choose your payment method'
      },
      SUBTITLE: 'Select a payment method to pay for your subscription and activate your tracker.'
    },
    TUNNEL: {
      SERENITY_PACK: {
        DESCRIPTION1: 'Priority support and replacement of your tracker in case of loss, damage, or theft — no proof required.',
        DESCRIPTION2: 'If your pet goes missing despite their tracker, our team will support you by creating outreach tools to help you find them.',
        TITLE: 'Serenity Pack'
      }
    },
    UNKNOWN_PAGE: {
      BUTTON: 'Return to the application',
      TEXT: 'The application encountered an unexpected state.',
      TITLE: 'Unknown step'
    }
  },
  subscriptionAlert: {
    ACTIVATE_AUTO_RENEWAL: 'Re-activate the automatic renewal',
    AUTO_RENEWAL_ADVICE: 'We advise you to re-activate the automatic renewal if you wish to extend your subscription',
    AUTO_RENEWAL_NOTICE: '<1>Warning !</1> Your {{trackerName}} tracker\'s subscription comes to an end and the automatic renewal is deactivated.',
    CONTINUE_BUTTON: 'Keep going',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'A problem occurred',
      UPDATE_SUCCESS: 'Successfully updated'
    },
    REMIND_LATER: 'Remind me later',
    SUPPORT_TEXT: 'If you have questions or you think this is a mistake, please contact our <1>customer service</1>.',
    TRIAL_CASE: {
      SUBSCRIBE_BUTTON: 'Take out a subscription',
      TRIAL_IS_OVER: 'Your trial period is over',
      TRIAL_IS_OVER_ADVICE: 'We hope your trial has been a success! To continue using the product, you now need to take out a subscription.'
    }
  },
  subscriptionOptionsSelection: {
    CANCEL_WARNING_MODAL_HEADLINE: 'Are you sure you want to disable this option?',
    CANCEL_WARNING_SMS: 'By disabling this option you will not receive alert notifications by SMS.',
    CANCEL_WARNING_WARRANTY: 'By disabling this option you will lose the added protection provided by the multi-risk guarantee.',
    EXPLANATION: 'Option payments are monthly.',
    EXPLANATION2: 'And cancellation is possible at any time.',
    EXPLANATION3: 'No payment will be made.',
    HINT: 'You can enable or disable an option at any time',
    MAIN_HEADLINE: 'Choose your options',
    SUBMIT_BUTTON: 'Confirm'
  },
  subscriptionPayment: {
    ERRORS: {
      UNKNOWN: 'There was a problem during the payment, please try again'
    },
    GIFT_CARD: {
      EXPLANATION: 'Enter the code written on the back of the card provided in your tracker pack.',
      I_HAVE_ONE: 'I have a gift Card',
      NEED_HELP: 'Do you need help with Gift Cards?',
      TITLE: 'Use your gift Card',
      USE: 'Use the card'
    },
    HEADLINE: 'Summary prior to payment',
    PROMOCODE_TEXT: 'I have a coupon code:',
    PROMO_CODE: 'Coupon code',
    PROMO_CODE_GIFT_CARD: 'Gift Card',
    SATISFIED_OR_REFUNDED: 'Satisfaction or refund',
    SATISFIED_OR_REFUNDED_DESCRIPTION: 'Try it risk-free for 30 days and if you are not satisfied we will refund you.',
    SELECT_PAYMENT_MEAN: 'First select a payment method and then pay for and activate your subscription.',
    SUBMIT_BUTTON: 'Pay for subscription',
    SUBMIT_BUTTON2: 'Activate the tracker',
    SUMMARY: 'Summary of your choices'
  },
  subscriptionProcess: {
    GIFT_CARD_EXPLANATION: 'Fill in your preferred payment method to activate your tracker for free.',
    GIFT_CARD_EXPLANATION2: 'This information is required for legal reasons related to the use of SIM cards.',
    RETURN_TO_APP: 'Back to the app',
    RETURN_TO_MAP: 'Return to map',
    RETURN_TO_TRACKERS: 'Back to the map',
    STEPS: [
      'Tracker',
      'Subscription',
      'Options',
      'Summary'
    ]
  },
  subscriptionSelection: {
    BEST_OFFER: 'BEST OFFER',
    CANCELABLE_AFTER_THREE_MONTHS: 'You can cancel at any time after the first three months',
    CANCEL_ANYTIME: 'You can cancel at any time',
    COMMITMENT_TEXT: 'Can be terminated at any time after the minimum commitment period of 3 months.',
    FEATURES: '',
    FEATURES_HEADLINE: 'All subscriptions include:',
    HEADLINE: 'Choose your subscription',
    MIN_THREE_MONTHS: 'Minimum commitment of three months',
    MONEY_BACK: 'All subscriptions are invoiced immediately but can be cancelled within 30 days, with full refund of the amount paid.',
    PAYMENT_MEANS: 'Payment by direct debit and credit card',
    REFUNDED_INFO: 'We refund the subscription without any conditions.',
    REFUNDED_TEXT: 'Money back guarantee for 30 days.',
    SIM_CARD_WARNING: 'Your tracker contains an integrated SIM card. This means it is necessary to have a subscription in order to cover the service charges.',
    SUBMIT_BUTTON: 'Confirm',
    XMAS_OFFER: {
      BODY: 'Nevertheless, we have to make you choose your future subscription now (for security reasons, as the product includes a SIM card). You will not be charged before the end of the 6 free months and can cancel this subscription at any time up to one month before its actual start date.',
      TITLE: 'Your tracker includes a 6-months prepaid subscription that was paid by your loved one.'
    },
    features: [
      '30 days satisfaction or refund',
      'Unlimited GPS localisation',
      'Push notifications (application) and emails',
      '10 minutes of voice call per month'
    ]
  },
  subscriptioncarousel: {
    CARDSBLOCK_1YEAR_PAYMENT: 'Payment of {{total_price}} every year.',
    CARDSBLOCK_1YEAR_TITLE: '1-year prepaid subscription',
    CARDSBLOCK_2YEARS_PAYMENT: 'Payment of {{total_price}} every two years.',
    CARDSBLOCK_2YEARS_TITLE: '2-year prepaid subscription',
    CARDSBLOCK_5YEARS_PAYMENT: 'Payment of {{total_price}} every five years.',
    CARDSBLOCK_5YEARS_TITLE: '5-year prepaid subscription',
    CARDSBLOCK_BADGE_GUARANTEE: 'Satisfaction guaranteed or your money back',
    CARDSBLOCK_BADGE_POPULAR: 'Popular offer',
    CARDSBLOCK_GUARANTEE: 'Satisfaction guaranteed or your money back: you have 30 days to change your mind.',
    CARDSBLOCK_MONTHLY_PAYMENT: 'Monthly payment with no commitment.',
    CARDSBLOCK_MONTHLY_TITLE: 'Monthly subscription',
    CARDSBLOCK_PERMONTH: '{{price}} / month',
    CARDSBLOCK_SEEMORE: 'See more subscriptions'
  },
  subscriptions: {
    BASE: 'Subscription',
    CANCEL_MODAL: {
      HEADLINE: 'Do you want to cancel the automatic renewal of your subscription?',
      HINT: 'Your subscription will still be active until {{date}} but it will not renew automatically.\nAfter this date you will no longer be able to locate your tracker.'
    },
    CHANGE_PLAN: {
      ADD_OPTIONS: 'Add an option',
      EXPLANATION: 'The subscription change will come into effect at the end of the current period.',
      HEADLINE: 'Change subscription?'
    },
    DETAILS: {
      ACTIVATE_BUTTON: {
        LABEL: 'Activate subscription'
      },
      ACTIVE_CASE: {
        MANAGE_BUTTON: 'Manage subscription',
        RENEWAL_INFO: 'Your subscription will be automatically renewed on {{date}} for {{price}}'
      },
      CANCELED: {
        EXPIRED_MAIN: 'Your subscription has expired. Reactivate the subscription to locate your tracker.',
        EXPIRED_SEC: 'Expired',
        UNCANCEL_BUTTON_LABEL: 'Re-activate the automatic renewal of the subscribtion',
        WILL_EXPIRE_DAYS: 'It expires in {{count}} day',
        WILL_EXPIRE_DAYS_plural: 'It expires in {{count}} days',
        WILL_EXPIRE_MAIN: 'Automatic renewal of the subscription has been cancelled. It will expire on {{date}}.'
      },
      CANCEL_RESILLIATION: 'Cancel termination request',
      NEW_CASE: {
        INFO_TEXT: 'We are having a problem with your payment. Please try again or change your payment method.',
        PAY_BUTTON: 'Pay and activate',
        WAITING_TEXT: 'We are currently processing your payment for the subscription of this tracker.'
      },
      NO_SUB: {
        INFO_TEXT: 'Activate the subscription to start using your tracker.'
      },
      RESILLIATION_ASKED: 'Termination requested',
      SUBSCRIBE_BUTTON: {
        LABEL: 'Take out a subscription'
      },
      SUPPORT_TEXT: 'Having trouble activating your tracker? Contact <1> Support </1>.',
      TRIAL_PERIOD_CASE: {
        END_INFO: 'Your trial period will end on {{ date }}'
      }
    },
    OFFERS: {
      SAVINGS: 'save {{price}}',
      SAVING_PER_YEAR: 'save {{amount}} /year'
    },
    OFFERS_TEXT: {
      MOST_POPULAR: 'Most popular',
      ONE_MONTH: {
        INFO: 'No commitment, cancellable at any time.',
        TITLE: '1 month package'
      },
      ONE_YEAR: {
        INFO: 'Trial period extended by 15 days: 30 days in total',
        TITLE: '1 year package'
      },
      THREE_YEAR: {
        INFO: '1 year additional manufacturer\'s warranty: 3 years in total',
        INFO2: '3-year manufacturer\'s warranty (instead of two).',
        TITLE: '3-year package'
      }
    },
    OVERVIEW: {
      OPTIONS: 'Options details',
      REG_DETAILS: 'Tracker details',
      REPLACE_TRACKER_BUTTON: {
        LABEL: 'Replace tracker'
      },
      SUB_DETAILS: 'Subscription details'
    },
    PLAN_NAMES: {
      FALLBACK: 'Subscription',
      ONE_MONTH: 'Monthly subscription',
      ONE_YEAR: '1-year prepaid subscription',
      THREE_YEARS: '3-year prepaid subscription',
      TRIAL_PERIOD: 'Trial period',
      TWO_YEARS: '2-year subscription'
    },
    STATUS: {
      ACTIVE: 'Subscribed',
      CANCELED: 'Cancelled',
      INACTIVE: 'Non-subscribed',
      NEW: 'Active',
      PENDING: 'Waiting'
    },
    TRACKER_DETAILS: {
      REGISTRATION_DATE: 'Activation date',
      WARRANTY: 'Standard guarantee'
    }
  },
  superLive: {
    ACTIVE_TEXT: 'Superlive is enabled.',
    HEADLINE: 'Super live mode',
    MESSAGES: {
      SUCCESS_ACTIVATED: 'Super live mode activated - One position every {{frequency}} seconds for 5 minutes'
    },
    TIME: 'Position taken every {{frequency}} seconds'
  },
  support: {
    FORM: {
      MESSAGE: {
        LABEL: 'Your message*',
        PLACEHOLDER: ''
      },
      PROBLEM: {
        AVAILABLE_OPTIONS: 'Available options',
        LABEL: 'Type of problem encountered *'
      },
      SUBJECT: {
        LABEL: 'Subject of your request*',
        PLACEHOLDER: ''
      },
      TRACKER: {
        LABEL: 'Your request concerns which tracker? ',
        PLACEHOLDER: 'Select the tracker'
      }
    },
    HEADLINE: 'Support',
    HELP_CENTER: 'Help Center',
    HELP_TEXT: 'Need help? Visit our support centre to find the answer to your question. You can also contact us using the form below; our team will answer you within 24 business hours.',
    MAIN_TEXT: 'Our help centre compiles all our articles to answer all your questions.',
    MESSAGES: {
      SUBMIT_ERROR: 'An error has occurred, please try again',
      SUBMIT_SUCCESS: 'Message sent'
    },
    PROBLEM_TYPES: {
      CHARGE: 'My tracker is not charging normally',
      DOWNLOAD_APP: 'I cannot download the application',
      GPS_INVALID: 'My GPS signal is invalid',
      GPS_PRECISION: 'My tracker\'s GPS position is not accurate',
      LEDS_FIXED: 'The two leds of my tracker remain on',
      NO_GEOFENCE_ALERTS: 'I receive false geofence alerts',
      NO_NOTIFICATIONS: 'I do not receive notifications',
      OTHER: 'Other',
      SIGN_IN: 'I cannot login to my account',
      SUBSCRIPTION: 'I have a problem with my subscription',
      TRACKERS_PARAMS: 'I cannot set my the parameters of my tracker',
      TRACKER_NOT_CONNECTED: 'My tracker is shown as not connected'
    },
    SUBMITTED_TICKET: 'We have received your query, thank you.\nA confirmation email has been sent to you (please check your junk mail folder if you don\'t see it in your inbox).',
    SUB_TEXT: 'If these instructions aren\'t sufficient, you can also contact a member of our service team who will reply within 24 working hours.',
    TITLE: 'Need Help ?',
    URGENT_NUMBER: 'If your query is urgent, our Customer Services are available \n+33 (0)187 660 083 from 10 a.m. to 12 noon and from 2 p.m. to 5 p.m. Monday to Friday.'
  },
  trackerLeftPanel: {
    CALL: 'Voice call',
    CTR_ONLY_SECONDS: 'You have {{SECONDS}} second(s) left for call usage in current month.',
    CTR_WITH_MINUTES: 'You have {{MINUTES}} minute(s) and {{SECONDS}} second(s) left for call usage in current month.',
    FLASH: 'Flashlight',
    GOOD_GPS_ACCURACY: 'Good GPS precision',
    LAST_POSITION: 'Last known position:',
    MEDIUM_GPS_ACCURACY: 'Average GPS precision',
    OFFLINE: 'Tracker offline',
    POOR_GPS_ACCURACY: 'Bad GPS precision',
    RING: 'Ringing',
    SMS_AVAILABLE: 'Available SMS : {{SMS_count}}',
    VIBRATE: 'Buzzer'
  },
  trackerSettings: {
    BUTTONS: {
      LABELS: {
        BUTTON: 'Button'
      },
      PLACEHOLDER_BUTTON: 'Type the message to be sent by Alert {{button_number}}',
      TEXT: 'Write a message for each Alert on your locator. You\'ll get the message in your notifications when the button is pressed.'
    },
    CONTACTS: {
      ADD_EMAIL_BUTTON: 'Add an email address',
      ADD_PHONE_BUTTON: 'Add a phone number',
      EMAILS_LABEL: 'Email addresses for email notifications',
      MAIL: {
        PLACEHOLDER: 'votre@email.com'
      },
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'A problem was encountered, please try again',
        UPDATE_SUCCESS: 'Contacts updated '
      },
      NUMBERS_LABEL: 'Phone numbers for SMS notifications',
      PHONE: {
        PLACEHOLDER: '+33600000000'
      }
    },
    DISPLAY: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'A problem occurred',
        UPDATE_SUCCESS: 'Settings updated '
      },
      MODAL: {
        HEADLINE: 'Select the icon',
        TEXT: 'You can select the icon you want from the list below. It will represent your tracker on the map.'
      },
      TRACKER_ICON: {
        EDIT_TEXT: 'Change icon',
        LABEL: 'Tracker icon'
      },
      TRACKER_NAME: {
        LABEL: 'Tracker name',
        PLACEHOLDER: 'Name that will appear on the map'
      },
      TRACKER_TYPE: {
        CHANGE: 'Change tracker type',
        MODIFIED_SUCCESS: 'Type of tracker successfully modified'
      }
    },
    GENERAL_NAME_OF_THE_TRACKER: 'Tracker name',
    GENERAL_TITLE: 'General',
    GPS_FREQUENCY: {
      '10MIN': '10min',
      '10S': '10s',
      '1MIN': '1min',
      '2MIN': '2min',
      '30S': '30s',
      '3MIN': '3min',
      '5MIN': '5min',
      BATTERY_USAGE: 'Average battery life:',
      BATTERY_USAGE_LEVELS: {
        HIGH: 'High',
        LOW: 'Low',
        MEDIUM: 'Medium'
      },
      GEOFENCE_NOTIFICATIONS: 'Average response time for geofence alerts:',
      HINT: 'Greater reporting frequency reduces battery life but also improves response times of geofence entry and exit alerts. Conversely, lower reporting frequency improves battery life but reduces the responsiveness of geofence entry and exit alerts.',
      OFF: 'OFF',
      TEXT: 'Choose the GPS reporting time interval'
    },
    NOTIFICATION_SETTINGS: {
      APP: 'Application',
      BATTERY: {
        HINT: 'Sends a notification to all contacts when the tracker reaches a low battery level.',
        TITLE: 'Battery'
      },
      BUTTONS: {
        HINT: 'Sends a notification to all contacts when one of the lateral buttons is pressed. The message configured for this button will be included in the notification.',
        TITLE: 'Lateral buttons'
      },
      GEOFENCES: {
        HINT: 'Sends a notification to all contacts if the tracker enters or leaves a parameterised area.',
        TITLE: 'Safety areas'
      },
      MAIL: 'Email',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'A problem was encountered, please try again',
        UPDATE_SUCCESS: 'Notification settings have been updated'
      },
      POWERSAVINGAREA: {
        HINT: 'Sends a notification to all contacts when the tracker enters or leaves a configured area.',
        TITLE: 'Power-saving areas:'
      },
      SMS: 'SMS',
      SOS: {
        HINT: 'Sends a notification to all contacts when the SOS button is pressed.',
        TITLE: 'SOS Call'
      },
      WARNING: {
        SMS: {
          LINK: 'Click here to activate it.',
          TEXT: 'Please note, if you wish to receive SMS alerts, you must activate the corresponding option.'
        }
      }
    },
    REDIRECTION_MESSAGE: 'You can change these settings anytime in the Weenect mobile app.',
    SECTION_TITLES: {
      BUTTONS: 'Buttons',
      CONTACTS: 'Contacts for notifications',
      DISPLAY: 'General',
      GPS_FREQUENCY: 'Time interval between each GPS position',
      NOTIFICATION_SETTINGS: 'Types of notifications for each alert',
      SOS: 'SOS Number',
      TRAINING: 'Voice call'
    },
    TRAINING_SOS: {
      DIRECT_CALL: 'Call this number for SOS alerts.',
      INPUT_PLACEHOLDER: '+33600000000',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'A problem was encountered, please try again',
        UPDATE_SUCCESS: 'Phone number updated'
      },
      SOS_TEXT: 'Phone number that will receive calls in case of SOS alert',
      TRAINING_TEXT: 'Enter the default phone number that will be called by the tracker when using the phone function from the application. This number is can be edited for each call request from the application.'
    }
  },
  trackerprofile: {
    AVATAR_PROMPT: 'Add a photo',
    ERROR_REQUIRED: 'This field is required',
    NAME_PLACEHOLDER: 'Give this tracker a name',
    SUBMIT_CTA: 'Continue',
    SUBTITLE: 'A few details are enough to create a profile that suits them',
    TITLE_ANIMAL: 'Customize your companion\'s profile',
    TITLE_HUMAN: 'Customize your loved one\'s profile',
    TYPE_CAT: 'Cat',
    TYPE_CHILD: 'Child',
    TYPE_DOG: 'Dog',
    TYPE_ELDER: 'Elderly person',
    TYPE_PLACEHOLDER: 'Select the type of tracker'
  },
  trackerregistration: {
    ERROR_ALREADY_LINKED: 'This tracker is already linked to an account',
    ERROR_INCOMPLETE: 'The IMEI number must be 15 digits',
    ERROR_INVALID: 'Invalid IMEI number',
    SECTION_TITLE: 'Enter the tracker ID',
    SUBMIT_CTA: 'I confirm the identification number',
    SUBTITLE: 'You will find it on the back of your Weenect tracker, it consists of 15 digits'
  },
  trackers: {
    ADD_TRACKER_BUTTON: {
      LABEL: 'Add a tracker'
    },
    EXPIRATION: {
      EXPIRED: 'The subscription for {{tracker}} has expired',
      WILL_EXPIRE: 'The subscription for {{tracker}} will expire in {{days}} days'
    },
    LINKS: {
      ACTIVITY: 'Activity monitoring',
      GEOFENCES: 'Areas',
      HISTORY: 'History',
      SETTINGS: 'Parameters',
      SUBSCRIPTION: 'Subscription'
    }
  },
  trackersPositionRefresh: {
    MESSAGES: {
      NOT_REFRESHED: 'Your tracker has been unable to acquire new GPS positions',
      REFRESHING: 'Please wait, a refresh request is in progress.',
      SUCCESS: 'GPS positions of trackers successfully updated.'
    }
  },
  trackerstatus: {
    AIRPLANE: 'Tracker in airplane mode',
    BATTERY_OFF: 'Tracker turned off due to low battery',
    GSM_BAD: 'Weak',
    GSM_GOOD: 'Good',
    GSM_MEDIUM: 'Average',
    IN_AIRPLANE_MODE: 'Airplane mode',
    IN_POWER_SAVING_AREA: 'In power-saving area',
    LAST_COMMUNICATION_AGO: 'Last communication %s ago',
    LAST_COMMUNICATION_ON: 'Last position on %s',
    LAST_POSITION_AGO: 'Last position %s ago',
    LAST_POSITION_ON: 'Last position on %s',
    NO_BATTERY: 'No battery',
    NO_POSITION: 'No known position',
    NO_SUBSCRIPTION: 'No active subscription',
    OFFLINE: 'Tracker disconnected',
    OFFLINE_GSM: 'Off GSM network',
    OFFLINE_MANUAL: 'Manually switched off',
    ONLINE: 'Tracker connected',
    POSITION_BAD: 'Weak',
    POSITION_GOOD: 'Good',
    POSITION_MEDIUM: 'Average',
    POSITION_WIFI_NO_NAME: 'Unidentified',
    TURN_OFF: 'Tracker turned off manually'
  },
  trackertab: {
    AIRPLANE_MODE_LABEL: 'Airplane Mode',
    NOTIFICATIONS_ALERT_BUTTONS_SUBTITLE: 'Check the message assigned to buttons 2 and 3 on your tracker. You will receive this message if the button is pressed.',
    NOTIFICATIONS_ALERT_BUTTONS_TITLE: 'Alert buttons',
    NOTIFICATIONS_ALERT_ZONES_LABEL: 'Alert zones:',
    NOTIFICATIONS_BATTERY_LABEL: 'Battery:',
    NOTIFICATIONS_BUTTON_2_LABEL: 'Button 2',
    NOTIFICATIONS_BUTTON_3_LABEL: 'Button 3',
    NOTIFICATIONS_CONTACTS_SUBTITLE: 'Notification contacts',
    NOTIFICATIONS_CREDITS_CALL: 'You have {{minutes}} minute(s) and {{seconds}} second(s) of phone call time left for the current month.',
    NOTIFICATIONS_CREDITS_SMS: 'You have {{sms}} SMS left for the current month.',
    NOTIFICATIONS_CREDITS_TITLE: 'Remaining credits',
    NOTIFICATIONS_EMAIL_ADDRESSES_LABEL: 'Email addresses',
    NOTIFICATIONS_ENERGY_ZONES_LABEL: 'Power-saving areas:',
    NOTIFICATIONS_PHONE_NUMBERS_LABEL: 'Phone numbers',
    NOTIFICATIONS_SIDE_BUTTONS_LABEL: 'Side buttons:',
    NOTIFICATIONS_SOS_CALL_LABEL: 'SOS call:',
    NOTIFICATIONS_TYPES_SUBTITLE: 'Notification types for each alert',
    PROFIL_ICON_LABEL: 'Tracker icon',
    PROFIL_NAME_LABEL: 'Tracker name',
    PROFIL_SOS_PHONE_PLACEHOLDER: 'Phone number that will receive SOS calls',
    PROFIL_SOS_PHONE_TITLE: 'SOS call',
    PROFIL_TRACKER_CAT: 'Cat tracker',
    PROFIL_TRACKER_CHILD: 'Child tracker',
    PROFIL_TRACKER_DOG: 'Dog tracker',
    PROFIL_TRACKER_ELDER: 'Elderly tracker',
    PROFIL_TYPE_LABEL: 'Tracker type',
    ZONES_ALERTS_DANGER_SUBTITLE: 'Danger zones',
    ZONES_ALERTS_MOBILE_ONLY_NOTE: 'Zone editing and creation are done directly from the Weenect mobile app.',
    ZONES_ENERGY_MOBILE_ONLY_NOTE: 'Zone editing, creation, and Airplane Mode activation are done directly from the Weenect mobile app.',
    ZONE_ACTIVE_STATE: 'Active',
    ZONE_INACTIVE_STATE: 'Disabled'
  },
  transferPage: {
    ADD_TRACKER: 'I want to add a new tracker to my account',
    BACK_TO_TRACKERS: 'Back to the map',
    FIRST_TITLE: 'What do you want to do?',
    FROM_HEADLINE: 'Tracker to replace:',
    HEADLINE: 'Replace a tracker',
    IMEI_LABEL: 'IMEI number',
    INFO: 'The current subscription and settings will be transferred to the new tracker after replacement. The GPS location history from the previous tracker will be lost.',
    MESSAGES: {
      ERROR_UNKNOWN: 'A problem was encountered, please try again',
      SUCCESS: 'New tracker successfully assigned',
      WRONG_TYPE: 'The locator with that IMEI number is not the same type as your original locator. Please get in touch with our helpdesk.'
    },
    NAME_LABEL: 'Tracker name',
    PURCHASE: 'Don\'t have a Weenect tracker yet? <1> You can buy them here </1>',
    REPLACE_BUTTON: {
      LABEL: 'Replace'
    },
    REPLACE_TRACKER: 'I want to replace an existing tracker',
    TO_HEADLINE: 'New tracker:'
  },
  translation: {
    account_payment_sepa_mandate: 'SEPA mandate'
  },
  webappDisconnection: {
    BUG: 'Not connected',
    MANUAL: 'You have turned your tracker off. Press the ON button to turn it back on.',
    NO_BATTERY: 'Your tracker has turned off because the battery is exhausted.',
    NO_SUB: 'You have no active subscription for this tracker. Please set one up by going to'
  },
  weenectangels: {
    CARD_SEE_MORE: 'See more',
    CARD_STATUS_LOST: 'LOST',
    DETAIL_BREED: 'BREED',
    DETAIL_CHIPPED: 'CHIPPED',
    DETAIL_COLOR: 'COLOR',
    DETAIL_CTA_WEBSITE: 'Learn more on the website',
    DETAIL_EARS: 'EARS',
    DETAIL_FUR_DRAWING: 'COAT',
    DETAIL_FUR_SIZE: 'HAIR',
    DETAIL_GENDER: 'SEX',
    DETAIL_INFO: 'This feature can be changed anytime from your preferences. Click here to access it',
    DETAIL_LOST_ON: 'Missing since {{date}}',
    DETAIL_PHYSICAL_DESCRIPTION: 'PHYSICAL DESCRIPTION',
    DETAIL_REPORTED_ON: 'Reported on {{site}}',
    DETAIL_SIZE: 'SIZE',
    DETAIL_STATUS_LOST: 'LOST',
    DETAIL_STERILIZED: 'STERILIZED',
    DETAIL_TATTOOED: 'TATTOOED'
  },
  wifiZones: {
    AIRPLANE_TEXT: 'Warning: in airplane mode, you cannot make your tracker ring or vibrate, or manually refresh its position, while it\'s in the Power saving zone\n.',
    DEEP_SLEEP_TITLE: 'Airplane mode',
    DISPLAY_BUTTON: 'Display the area on the map',
    DISPLAY_TITLE: 'Notifications',
    IN_AIRPLANE: '- airplane mode',
    IN_OUT_TEXT: 'Area entrances and exits :',
    LAST_POS_IN_WIFI: 'In the power-saving area since {{date}} ',
    MAIL_NOTIF: 'Email notifications',
    NOTIF_TEXT: 'Get a notification for each area entry or exit. ',
    POPIN: {
      AIRPLANE: {
        BUTTON_VALIDATE: 'Exit airplane mode',
        CONTENT: 'You can no longer communicate with your tracker while it is in the <span style="color: #333333; font-family: Verdana, sans-serif;"><span>Power saving zone</span></span>. If you want to regain full functionality,<strong> turn off airplane mode and take the tracker out of the zone</strong>.',
        TITLE: 'Your tracker is in airplane mode in the {{wifiName}} power-saving area.'
      },
      BUTTON_CLOSE: 'Do it later',
      BUTTON_VALIDATE: 'Disable this area',
      CONTENT: 'In this area, automatic reporting of your tracker\'s GPS locations is disabled because we know it is located within the area. You can disable this area at any time from the "Tracker" tab.',
      TITLE: 'Your tracker is in the {{wifiName}} power-saving area.'
    },
    PUSH_NOTIF: 'Push notifications',
    SMS_NOTIF: 'Text notifications',
    TITLE: 'Power-saving area',
    ZONE_ACTIVATION: 'Enable the area'
  }
}
